'use strict';

/**
 * @ngdoc overview
 * @name ngBusApp
 * @description
 * # ngBusApp
 *
 * Main module of the application.
 */

! function(window, angular, undefined) {
    var RANDOM_NO = Math.floor((new Date()).getTime() / 1000 / (60 * 5));
    angular
        .module('ngBusApp', [
            'ngRoute',
            'ngSanitize',
            'ui.bootstrap'
            /*,'whimsicalRipple'*/
        ])
        .constant("CONSTANTS", {
            // 'ENV':'PROD',
            'ENV': ENV,
            'RANDOM_STR_NO_SLASH': "&_=" + RANDOM_NO,
            'RANDOM_STR_WITH_SLASH': "/&_=" + RANDOM_NO,
            'HOME_BREADCRUMB': { 'name': 'Home', 'url': '/' },
            'DATE_REGEX': /^(3[0-1]|[0-2][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/\d{4}/,
            // 'DATE_REGEX': /^(1[0-2]|0?[1-9])\/(3[0-1]|[0-2][0-9]|[1-9])\/\d{4}/,
            'OPEN_MODAL': 'open-modal',
            'CLOSE_MODAL': 'close-modal',
            'DATE_FORMAT': 'EEE, dd MMM yyyy',
            'IS_LOGGED_IN': 'isloggedin',
            'AFTER_ACTION': 'after-action',
            'DOMAIN': "http://www.travelyaari.com/",
            'API_URL': (ENV === "PROD" ? '' : '//dev.travelyaari.com'),
            'TRACK_GA': 'trackGA',
            'GDS_TOKEN': gds_token ? gds_token : '893E2A2365750132B4DB8C8B6510E5A4|333-S|201704181447|0|FFFF',
            'GDS_API_URL': "https://stgotaapi.iamgds.com",
            'GDS_TRANS_API_URL': "https://stgotaapi.iamgds.com",
        })
        .config(['$routeProvider', '$httpProvider', '$locationProvider', 'CONSTANTS', '$provide',
            function($routeProvider, $httpProvider, $locationProvider, CONSTANTS, $provide) {
                var setBoolForRootscopeFn = function(arr) {
                    var arr = arr || [];
                    return function($rootScope) {
                        $rootScope.isHeaderFixed = arr.indexOf('headerFixed') === -1 ? false : true;
                        $rootScope.isHeaderClickable = arr.indexOf('headerClickable') === -1 ? false : true;
                        $rootScope.header.isHeaderSearchType = arr.indexOf('headerSearchType') === -1 ? false : true;
                        $rootScope.header.isHeaderInfoType = arr.indexOf('headerInfoType') === -1 ? false : true;
                    };
                }

                $routeProvider
                    .when('/account/', {
                        templateUrl: 'views/myaccount.html',
                        controller: 'MyAccountCtrl',
                        controllerAs: 'myaccount',
                        reloadOnSearch: false,
                        resolve: {
                            setBoolValue: ['$rootScope', setBoolForRootscopeFn()]
                        }
                    })
                    .when('/account/:module', {
                        templateUrl: 'views/myaccount.html',
                        controller: 'MyAccountCtrl',
                        controllerAs: 'myaccount',
                        reloadOnSearch: false,
                        resolve: {
                            setBoolValue: ['$rootScope', setBoolForRootscopeFn()]
                        }
                    })
                    .when('/:urlType/:viewType/details/:token', {
                        templateUrl: 'views/details.html',
                        controller: 'BookingDetailsCtrl',
                        controllerAs: 'bookingdetails',
                        reloadOnSearch: false,
                        resolve: {
                            setBoolValue: ['$rootScope', setBoolForRootscopeFn()]
                        }
                    })
                    .when('/user/verify', {
                        templateUrl: 'views/verifyuser.html',
                        controller: 'VerifyUserCtrl',
                        controllerAs: 'verifyuser',
                        reloadOnSearch: false,
                        resolve: {
                            setBoolValue: ['$rootScope', setBoolForRootscopeFn()]
                        }
                    })
                    .when('/user/my-bookings', {
                        templateUrl: 'views/loginoptions.html',
                        controller: 'LoginMethodCtrl',
                        controllerAs: 'user',
                        reloadOnSearch: false,
                        resolve: {
                            setBoolValue: ['$rootScope', setBoolForRootscopeFn()]
                        }
                    })
                    .when('/user/:module', {
                        templateUrl: 'views/userbookings.html',
                        controller: 'UserCtrl',
                        controllerAs: 'user',
                        reloadOnSearch: false,
                        resolve: {
                            setBoolValue: ['$rootScope', setBoolForRootscopeFn()]
                        }
                    })
                    .otherwise({
                        redirectTo: '/'
                    });

                $provide.decorator("$exceptionHandler", ["$delegate", "$window", function($delegate, $window) {
                    return function(exception, cause) {
                        if (CONSTANTS.ENV == "PROD" && $window.trackJs) {
                            // Track error and log anything else of interest.
                            $window.trackJs.track(cause + " O~~~O " + exception);
                        }
                        // if (CONSTANTS.ENV == "DEV") {
                        // In *non-production* environments you may still want the error sent to the console.
                        // You can delegate to the original handler (console.error) if you'd like.
                        // Warning, this can cause double tracking of errors, so do not use in production.
                        $delegate(exception, cause);
                        // }
                    };
                }]);

                // $httpProvider.interceptors.push([
                //     function() {
                //         return {
                //             'request': function(config) {
                //                 if (CONSTANTS.ENV == 'PROD' && /^\/views.+\.html$/.test(config.url)) {
                //                     var matches = window.location.pathname.match(/^(\/\w+)\/?/);
                //                     config.url = matches[matches.length-1]+config.url;
                //                 }
                //                 return config;
                //             }
                //         };
                //     }
                // ]);

                $locationProvider.html5Mode({
                    enabled: true,
                    requireBase: false
                }).hashPrefix('!');
            }
        ]).run(['$http', 'CONSTANTS', '$rootScope', '$routeParams', '$timeout', 'commonFactory', 'anchorSmoothScroll',
            function($http, CONSTANTS, $rootScope, $routeParams, $timeout, commonFactory, anchorSmoothScroll) {
                var hasTransformSupport = (function() {
                    var div = document.createElement('div');
                    return (div.style.transform !== undefined ||
                            div.style.webkitTransform !== undefined ||
                            div.style.MozTransform !== undefined ||
                            div.style.OTransform !== undefined ||
                            div.style.msTransform !== undefined) &&
                        navigator.userAgent.indexOf('Opera Mini') === -1;
                })();

                function getAllModalPropertiesFn() {
                    var modalProps = [];
                    for (var a in $rootScope.modalProperties) {
                        modalProps.push(a);
                    }

                    return modalProps;
                }

                function getScrollTop() {
                    if (typeof pageYOffset != 'undefined') {
                        //most browsers except IE before #9
                        return pageYOffset;
                    } else {
                        var B = document.body; //IE 'quirks'
                        var D = document.documentElement; //IE with doctype
                        D = (D.clientHeight) ? D : B;
                        return D.scrollTop;
                    }
                }

                /* properties ,methods and event needed for $rootScope */
                $rootScope.transformSupportClass = hasTransformSupport ? "ty-transform-support" : "ty-transform-nosupport";

                $rootScope.metaProperties = {
                    data: {}
                };

                // Modal properties
                $rootScope.slideList = false;
                $rootScope.modalShow = false;
                $rootScope.fixedBody = false;
                $rootScope.modalProperties = {
                    'menu': false,
                    'menuRightShow': false,
                    'customercare': false,
                    'loggedin': false
                };

                // Navbar property
                $rootScope.navbar = {
                    'show': false
                };

                // Header property
                $rootScope.header = {
                    'title': "",
                    'isLogoVisible': false,
                    'isMenuRightVisible': false,
                    'isHeaderSearchType': false,
                    'isHeaderInfoType': false
                };

                $rootScope.footer = {
                    show: false
                }

                $rootScope.$on('$routeChangeStart', function() {
                    $timeout(function() {
                        $rootScope.$broadcast(CONSTANTS.CLOSE_MODAL);
                    });
                });
                $rootScope.$on('$routeChangeSuccess', function() {
                    $timeout(function() {
                        $rootScope.rootCategory = $routeParams.category;
                    }, 1000);
                });

                $rootScope.$on(CONSTANTS.OPEN_MODAL, function(e, props) {
                    var props = props !== undefined && props.length !== undefined && props.length !== 0 && props || [];
                    props.forEach(function(item, index) {
                        $rootScope.modalProperties[item] = true;
                    });
                    try {
                        $rootScope.$digest();
                    } catch (err) {}
                });

                $rootScope.$on(CONSTANTS.CLOSE_MODAL, function(e, props) {
                    var props = props !== undefined && props.length !== undefined && props.length !== 0 && props || getAllModalPropertiesFn();
                    props.forEach(function(item, index) {
                        $rootScope.modalProperties[item] = false;
                    });
                    $rootScope.fixedBody = false;
                    $rootScope.slideList = false;
                    $rootScope.modalShow = false;
                    try {
                        $rootScope.$digest();
                    } catch (err) {}
                });

                function closeModalFn(props, $event) {
                    if ($event) {
                        $rootScope.stopEventFromBubbling($event);
                    }
                    $rootScope.$broadcast(CONSTANTS.CLOSE_MODAL, props);
                };

                $rootScope.openModal = function(props, $event) {
                    if ($event) {
                        $rootScope.stopEventFromBubbling($event);
                    }
                    closeModalFn(props);
                    $rootScope.$broadcast(CONSTANTS.OPEN_MODAL, props);
                    document.body.style.top = -getScrollTop() + "px";
                    $rootScope.modalShow = true;
                };

                $rootScope.closeModal = function(props, $event) {
                    var documentTop = Math.abs(document.body.style.top.replace(/[a-z]/gi, ""));
                    closeModalFn(props, $event);
                    $timeout(function() {
                        document.body.style.top = "initial";
                        window.scrollTo(0, documentTop);
                    }, 0, false);
                };

                $rootScope.toggleModal = function(prop, $event) {
                    if ($event) {
                        $rootScope.stopEventFromBubbling($event);
                    }
                    if ($rootScope.modalProperties[prop] === true) {
                        closeModalFn([prop], $event);
                    } else {
                        closeModalFn();
                        $rootScope.openModal([prop], $event);
                    }
                }

                $rootScope.preventDefaultBehaviour = function(e) {
                    e.preventDefault();
                };

                $rootScope.stopEventFromBubbling = function(e) {
                    e.stopPropagation();
                };

                $rootScope.goToTop = function() {
                    anchorSmoothScroll.scrollTo("header-container");
                };

                $rootScope.$on(CONSTANTS.IS_LOGGED_IN, function(e, data) {
                    $rootScope.authData = data.data;
                });

                $rootScope.goBack = function() {
                    $rootScope.$broadcast('goBack', $routeParams);
                };
                /* END : properties ,methods and event needed for $rootScope */

                // $http({
                //     'cache': true,
                //     'url': CONSTANTS.API_URL + '/api/v2/account/checkIfUserLoggedIn/',
                //     'method': 'GET'
                // }).then(function(data) {
                //     $rootScope.$broadcast(CONSTANTS.IS_LOGGED_IN, data);
                // });

                $rootScope.authData = {
                    logged_in: logged_in,
                    name: user_name
                };

                /* Scroll to top functionality */
                var scrollToTopId;

                function windowScrollTopFn() {
                    return window.pageYOffset || document.documentElement.scrollTop;
                }

                function onScrollTopShowElemFn() {
                    if (windowScrollTopFn() > 300) {
                        Array.prototype.forEach.call(document.getElementsByClassName('ty-scrollto-top'), function(item, index) {
                            item.style.display = "block";
                        });
                    } else {
                        Array.prototype.forEach.call(document.getElementsByClassName('ty-scrollto-top'), function(item, index) {
                            item.style.display = "none";
                        });
                    }
                }

                onScrollTopShowElemFn();
                window.addEventListener('scroll', function() {
                    clearTimeout(scrollToTopId);
                    scrollToTopId = setTimeout(onScrollTopShowElemFn, 300);
                });
            }
        ]);
}(window, angular);

'use strict';

/**
 * @ngdoc function
 * @name ngBusApp.controller:MyAccountCtrl
 * @description
 * # MyAccountCtrl
 * Controller of the ngBusApp
 */
angular.module('ngBusApp')
    .controller('MyAccountCtrl', ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService',
        function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService) {

            $rootScope.header.title = "My Account";
            $rootScope.footer.show = true;

            function changeModuleFn(module) {
                $scope.currentModule = module;
            }

            function changeTierLabelColorFn(color) {
                if (color) {
                    return 'ty-' + color.toLowerCase();
                } else {
                    return '';
                }
            }

            function uploadProfileImageFn() {
                if ($scope.profileImage) {
                    accountService.uploadProfielImage($scope.profileImage);
                }
            }

            function initFn() {
                changeModuleFn($routeParams.module);
                accountService.getLoyaltyDetails(false)
                $scope.urlType = 'account';
                $scope.accountData = accountData;
                $routeParams.module || ($scope.currentModule = accountData.accountOptions[1].module);
            }

            // Attach functions to scope
            $scope.changeModule = changeModuleFn;
            $scope.changeTierLabelColor = changeTierLabelColorFn;

            initFn();

            $scope.$on('$locationChangeSuccess', function(next, current) {
                accountData.message = '';
                accountData.error = false;
            });
        }
    ]);

'use strict';

/**
 * @ngdoc function
 * @name ngBusApp.controller:UserCtrl
 * @description
 * # UserCtrl
 * Controller of the ngBusApp
 */
angular.module('ngBusApp')
    .controller('UserCtrl', ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'userVerificationData', 'userVerificationService', 'cookieService', 'accountData',
        function(CONSTANTS, $routeParams, $location, $rootScope, $scope, userVerificationData, userVerificationService, cookieService, accountData) {

            function changeModuleFn(module) {
                $scope.currentModule = module;
            }

            function initFn() {
                $rootScope.footer.show = true;
                getBookingDataFn();
                changeModuleFn($routeParams.module);
                $scope.urlType = 'user';

                $scope.userVerificationData = userVerificationData;
                $routeParams.module || ($scope.currentModule = userVerificationData.userOptions[0].module);
            }

            function getBookingDataFn() {
                var email = cookieService.readCookie('_uemail'),
                    mobile = cookieService.readCookie('_umobile'),
                    otp = cookieService.readCookie('_uotp'),
                    type, contactInfo;

                if (email) {
                    type = 'email';
                    contactInfo = email;
                }

                if (mobile) {
                    type = 'mobile';
                    contactInfo = mobile;
                }
                
                if (type && contactInfo && otp) {
                    userVerificationService.getBookingDetails(type, contactInfo, otp).then();
                    $scope.accountData = accountData;
                } else {
                    $location.path('/user/verify');
                }
            }

            // Attach functions to scope
            $scope.changeModule = changeModuleFn;

            initFn();

            $scope.$on('$locationChangeSuccess', function(next, current) {
                userVerificationData.message = '';
                userVerificationData.error = false;
            });
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:ngLazyLoadImg
 * @description
 * # ngLazyLoadImg
 */
angular.module('ngBusApp')
    .directive('ngLazyLoadImg', ['$window', '$rootScope', '$timeout', function($window, $rootScope, $timeout) {
        var objOfOnLoadImgElems = {},
            objOfLazyImgElems = {},
            objOfLazyImgElemsInViewport = {},
            arrOfPrevDisplayedElements = [],
            loadTimeoutId,
            scrollTimeoutId,
            resizeTimeoutId,
            ngLazyLoadImg = {
                scope: {
                    'defaultImage': '=?',
                    'unLoadOnScroll': '=?',
                    'imgsrc': '=',
                    'onWinLoad': '=?'
                },
                replace: true,
                template: function(elem, attrs) {
                    return attrs.elemType == 'img' ?
                        '<img class="ty-async-img" ng-src="{{tyShow.imgsrc}}" ng-class="{\'loaded\':loaded}"></img>' :
                        '<div class="ty-async-img" ng-style="{\'background-image\':\'url(\'+tyShow.imgsrc+\')\'}" ng-class="{\'loaded\':loaded}"></div>';
                },
                restrict: 'E',
                controllerAs: 'tyShow',
                controller: ['$scope', '$element',
                    function($scope, $element) {
                        var that = this,
                            $elementOffsetTop = $element[0].getBoundingClientRect().top;

                        function populateLazyElemsFn(obj) {
                            if (obj[$elementOffsetTop] === undefined) {
                                obj[$elementOffsetTop] = [];
                            }
                            obj[$elementOffsetTop].push({
                                'that': that,
                                'scope': $scope,
                                'elem': $element
                            });
                        }

                        that.imgsrc = $scope.defaultImage;

                        if (!$scope.onWinLoad) {
                            $scope.unLoadOnScroll = $scope.unLoadOnScroll === undefined ? true : $scope.unLoadOnScroll;
                            populateLazyElemsFn(objOfLazyImgElems);
                        } else {
                            $scope.unLoadOnScroll = $scope.unLoadOnScroll === undefined ? false : $scope.unLoadOnScroll;
                            populateLazyElemsFn(objOfOnLoadImgElems);
                        }

                        $timeout.cancel(loadTimeoutId);
                        loadTimeoutId = $timeout(executeWhenAllLoaded, 300);
                    }
                ],
                link: function postLink(scope, element, attrs) {}
            };

        function getDocumentHeight() {
            var body = document.body,
                html = document.documentElement,
                height = Math.max(body.scrollHeight, body.offsetHeight,
                    html.clientHeight, html.scrollHeight, html.offsetHeight);

            return height;
        }

        function setImageIfInViewportFn(obj, forceLoad) {
            var doc = document.documentElement,
                $windowScrollTop = ($window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
                $windowHeight = window.outerHeight,
                $documentHeight = getDocumentHeight(),
                arrOfPrevDisplayedElementsCopy = arrOfPrevDisplayedElements;

            arrOfPrevDisplayedElements = [];
            arrOfPrevDisplayedElementsCopy.forEach(function(item, index) {
                var eachElemClientRect = item.elem[0].getBoundingClientRect(),
                    $elementOffsetTop = eachElemClientRect.top +
                    ($windowScrollTop - $windowHeight),
                    offsetTop = (eachElemClientRect.height !== 0 ? $elementOffsetTop : $documentHeight + 10);
                if ((offsetTop < $windowScrollTop - $windowHeight - eachElemClientRect.height) || offsetTop > $windowScrollTop) {
                    item.scope.loaded = false;
                }
            });
            for (var a in obj) {
                var eachBlock = obj[a];
                for (var i = 0, len = eachBlock.length; i < len; i++) {
                    eachBlock[i].scope.$watch('imgsrc', (function(eachElem) {
                        return function(imgSrc) {
                            var img = document.createElement('img');
                            img.src = eachElem.scope.imgsrc;
                            img.onload = function(eachElem) {
                                if (eachElem.scope.unLoadOnScroll) {
                                    arrOfPrevDisplayedElements.push(eachElem);
                                }
                                return function() {
                                    eachElem.that.imgsrc = eachElem.scope.imgsrc;
                                    eachElem.scope.loaded = true;
                                    eachElem.scope.$digest();
                                }
                            }(eachElem);

                            img.onerror = function() {
                                eachElem.scope.loaded = true;
                                eachElem.scope.$digest();
                            };
                        };
                    })(eachBlock[i]));
                }
            }
        }

        function addValueToObjArrProp(obj, prop, value) {
            if (obj[prop] === undefined) {
                obj[prop] = [];
            }

            obj[prop].push(value);
        }

        function recalculateOffsetFn() {
            var lazyObjCopy = objOfLazyImgElems,
                doc = document.documentElement,
                $windowScrollTop = ($window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
                $windowHeight = window.outerHeight,
                $documentHeight = getDocumentHeight();
            objOfLazyImgElemsInViewport = {};
            objOfLazyImgElems = {};

            for (var a in lazyObjCopy) {
                var eachObj = lazyObjCopy[a];
                for (var i = 0, len = eachObj.length; i < len; i++) {
                    var eachElem = eachObj[i],
                        eachElemClientRect = eachElem.elem[0].getBoundingClientRect(),
                        $elementOffsetTop = eachElemClientRect.top +
                        ($windowScrollTop - $windowHeight),
                        offsetTop = (eachElemClientRect.height !== 0 ? $elementOffsetTop : $documentHeight + 10),
                        newEachElemObj = {
                            'that': eachElem.that,
                            'scope': eachElem.scope,
                            'elem': eachElem.elem
                        };

                    addValueToObjArrProp(objOfLazyImgElems, offsetTop, newEachElemObj);

                    if ((offsetTop >= $windowScrollTop - $windowHeight - eachElemClientRect.height) && offsetTop < $windowScrollTop) {
                        addValueToObjArrProp(objOfLazyImgElemsInViewport, offsetTop, newEachElemObj);
                    }
                }
            }
        }

        function executeWhenAllLoaded() {
            setImageIfInViewportFn(objOfOnLoadImgElems, true);
            recalculateOffsetFn();
            setImageIfInViewportFn(objOfLazyImgElemsInViewport, false);
        }

        window.addEventListener('scroll', function() {
            $timeout.cancel(scrollTimeoutId);
            scrollTimeoutId = $timeout(function() {
                recalculateOffsetFn();
                setImageIfInViewportFn(objOfLazyImgElemsInViewport, false);
            }, 300);
        }, false);

        window.addEventListener('resize', function() {
            $timeout.cancel(resizeTimeoutId);
            resizeTimeoutId = $timeout(function() {
                recalculateOffsetFn();
                setImageIfInViewportFn(objOfLazyImgElemsInViewport, false);
            }, 300);
        }, false);

        $rootScope.$on('trigger.lazyload', function(e) {
            $timeout(function() {
                recalculateOffsetFn();
                setImageIfInViewportFn(objOfLazyImgElemsInViewport, false);
            }, 300);
        });

        return ngLazyLoadImg;
    }]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:breadcrumbCategory
 * @description
 * # breadcrumbCategory
 */
angular.module('ngBusApp')
    .directive('tyBreadcrumbCategory', function() {
        return {
            scope: {
                'content': '='
            },
            replace: true,
            template: '' +
                '<ol class="ty-breadcrumb" vocab="http://schema.org/" typeof="BreadcrumbList">' +
                '   <li property="itemListElement" typeof="ListItem">' +
                '       <a property="item" typeof="WebPage" class="ty-link" ng-repeat="eachcontent in ::content track by $index" ng-href="{{::eachcontent.url}}" ng-class="{\'ty-category\':$index!==0}">' +
                '           <span property="name">{{::eachcontent.name}}</span>' +
                '       </a>' +
                '   </li>' +
                '</ol>',
            restrict: 'E',
            link: function postLink(scope, element, attrs) {}
        };
    });
'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.commonFactory
 * @description
 * # commonFactory
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('commonFactory', function() {
        var common = {
            'seoDetails': {
                data: {}
            },
            isApp: function() {
                if (window.Android) {
                    return true;
                }
                return false;
            },
            setTitle: function(title) {
                if (window.Android) {
                    Android.onPageLoaded(title);
                }
            },
            isStorageSupported: function() {
                if (typeof Storage !== "undefined") {
                    return true;
                }
                return false;
            }(),
            storeToLocalStorage: function(prop, value) {
                if (common.isStorageSupported) {
                    if (Object.prototype.toString.call(value) == '[object Object]') {
                        localStorage.setItem(prop, JSON.stringify(value));
                    } else {
                        localStorage.setItem(prop, value);
                    }
                }
            },
            getFromLocalStorage: function(prop) {
                if (common.isStorageSupported) {
                    var propValue = localStorage.getItem(prop);
                    return propValue === null ? {} : JSON.parse(propValue);
                }
            },
            deleteItemFromStorage: function(prop) {
                if (common.isStorageSupported) {
                    localStorage.removeItem(prop);
                }
            }
        };

        return common;
    });

'use strict';

/**
 * @ngdoc filter
 * @name ngBusApp.filter:joinfilters
 * @function
 * @description
 * # joinfilters
 * Filter in the ngBusApp.
 */
angular.module('ngBusApp')
    .filter('joinfilters', ['$timeout', function() {
        return function(input) {
            var filtersStr = "",
                category;
            for (var a in input) {
                category = input[a].values;
                for (var j = 0, len = category.length; j < len; j++) {
                    if (category[j].isAvailable && category[j].isChecked) {
                        filtersStr += category[j].name + " ,";
                    }
                }
            }
            return filtersStr.replace(/\,$/, "");
        };
    }]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyScrollToElem
 * @description
 * # tyScrollToElem
 */
angular.module('ngBusApp')
	.directive('tyScrollToElem', function () {
		return {
		  restrict: 'A',
		  link: function postLink(scope, element, attrs) {
		    element.bind('focus', function(e){
		    	var elemBoundingRect = angular.element(e.currentTarget)[0].getBoundingClientRect();
		    	window.scrollTo(0, elemBoundingRect.top - 60);
		    });
		  }
		};
  	});

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tySlideLayer
 * @description
 * # tySlideLayer
 */
angular.module('ngBusApp')
    .directive('tySlideLayer', function() {
        return {
            scope: {
            	slideList:"=",
            	showSlide:"="
            },
            templateUrl: 'views/tyslidelayer.html',
            restrict: 'E',
            replace: true,
            transclude: true,
            controller: ['$rootScope','$scope', function($rootScope,$scope) {
            	$scope.transformSupportClass = $rootScope.transformSupportClass;
            }]
        };
    });

'use strict';

/**
 * @ngdoc filter
 * @name ngBusApp.filter:generateAltFromUrl
 * @function
 * @description
 * # generateAltFromUrl
 * Filter in the ngBusApp.
 */
angular.module('ngBusApp')
    .filter('generateAltFromUrl', function() {
        return function(input) {
            try {
                var input = (input || ""),
                    indexOfInput = input.lastIndexOf("/") + 1;

                return input
                    .substr(indexOfInput)
                    .replace(/\.\w+/g, "")
                    .replace(/[\_,\-]/g, " ")
                    .trim();
            } catch (err) {
                return "";
            }
        };
    });

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyValidateOnKeypress
 * @description
 * # tyValidateOnKeypress
 */
angular.module('ngBusApp')
    .directive('tyValidateOnKeypress', function() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, elem, attrs, ngModel) {
                var inputType = attrs.tyValidateOnKeypress;

                angular.element(elem).on("input", function(e) {
                    var inputText = e.currentTarget.value;

                    if (inputType == "email") {
                        var resultText = inputText.replace(/[^.@_0-9a-zA-Z]/g, "");
                        ngModel.$setViewValue(resultText);
                        ngModel.$render();
                    } else if (inputType == "number") {
                        var resultText = inputText.replace(/[^0-9]/g, '');
                        ngModel.$setViewValue(resultText);
                        ngModel.$render();
                    } else if (inputType == "name") {
                        var resultText = inputText.replace(/[^a-zA-Z ]/g, '');
                        ngModel.$setViewValue(resultText);
                        ngModel.$render();

                    }

                });
            }
        };
    });

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.analytics
 * @description
 * # analytics
 * Service in the ngBusApp.
 */
angular.module('ngBusApp')
    .service('analytics', ['$rootScope', '$location', 'CONSTANTS',
        function($rootScope, $location, CONSTANTS) {
            var track = function() {
                ga('send', { 'hitType': 'pageview', 'page': $location.path() });
            };
            $rootScope.$on(CONSTANTS.TRACK_GA, track);
        }
    ]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.facebookService
 * @description
 * # facebookService
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('facebookService', function() {
        // Service logic
        // ...

        var fbObject = {};

        // Public API here
        return {
            pageViews: function() {
                fbq('track', "PageView");
            },
            viewContent: function(content_name, content_category, value) {
                fbq('track', 'ViewContent', {
                    content_name: content_name, // Page title
                    content_category: content_category, // one of the value from Bus, Tour, Activity, Hotel
                    value: value, //default price for product pages
                    currency: 'INR' //
                });
            },
            search: function(search_string, content_category, value) {
                fbq('track', 'Search', {
                    search_string: search_string, //Bus - From-To pairs, Tour: destination, Activity: Activity type or Destination, Hotel: Destination
                    content_category: content_category, // Bus - 'Bus Search', Tour - 'Tour Search', Activity - 'Activity Search', Hotel - 'Hotel Search'
                    value: value, // Average Price of the page = sum total of all price shown divided by items shown
                    currency: 'INR'
                }); // Currency
            }
        };
    });

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.anchorSmoothScroll
 * @description
 * # anchorSmoothScroll
 * Service in the ngBusApp.
 */
angular.module('ngBusApp')
    .service('anchorSmoothScroll', [function() {
        // AngularJS will instantiate a singleton by calling "new" on this function
        this.scrollTo = function(eID, fixedContainerId) {

            // This scrolling function 
            // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

            var startY = currentYPosition();

            if (fixedContainerId === undefined) {
                var stopY = elmYPosition(eID);
            } else {
                var $el = document.getElementById(fixedContainerId);
                var stopY = elmYPosition(eID) - $el.offsetHeight;
            }

            var distance = stopY > startY ? stopY - startY : startY - stopY;
            if (distance < 100) {
                scrollTo(0, stopY);
                return;
            }
            var speed = Math.round(distance / 100);
            if (speed >= 20) speed = 20;
            var step = Math.round(distance / 25);
            var leapY = stopY > startY ? startY + step : startY - step;
            var timer = 0;
            if (stopY > startY) {
                for (var i = startY; i < stopY; i += step) {
                    setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                    leapY += step;
                    if (leapY > stopY) leapY = stopY;
                    timer++;
                }
                return;
            }
            for (var i = startY; i > stopY; i -= step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY -= step;
                if (leapY < stopY) leapY = stopY;
                timer++;
            }

            function currentYPosition() {
                // Firefox, Chrome, Opera, Safari
                if (self.pageYOffset) return self.pageYOffset;
                // Internet Explorer 6 - standards mode
                if (document.documentElement && document.documentElement.scrollTop)
                    return document.documentElement.scrollTop;
                // Internet Explorer 6, 7 and 8
                if (document.body.scrollTop) return document.body.scrollTop;
                return 0;
            }

            function elmYPosition(eID) {
                var elm = document.getElementById(eID);
                var y = elm.offsetTop;
                var node = elm;
                while (node.offsetParent && node.offsetParent != document.body) {
                    node = node.offsetParent;
                    y += node.offsetTop;
                }
                return y;
            }

        };
    }]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyBusHeader
 * @description
 * # tyBusHeader
 */
angular.module('ngBusApp')
    .directive('tyBusHeader', ['accountData', 'accountService',
        function(accountData, accountService) {
            return {
                scope: true,
                templateUrl: 'views/tybusheader.html',
                restrict: 'E',
                replace: true,
                controller: ['$scope', '$timeout', function($scope, $timeout) {
                    var searchValues = accountData.searchValues;

                    function setFromCityFn(value) {
                        accountService.setSearchValues('fromCity', value);
                    };

                    $scope.setFromCity = setFromCityFn;
                }]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.accountData
 * @description
 * # accountData
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('accountData', ['CONSTANTS', function(CONSTANTS) {
        var accountData = {
            'accountOptions': [{
                title: "Edit Profile",
                icon: 'icon-edit-profile',
                url: '/account/edit-profile',
                module: 'edit-profile',
                view: 'views/editprofile.html',
                seoDetails: {
                    title: 'Edit Profile: Edit your personal details by logging | Travelyaari'
                }
            }, {
                title: "View My Bookings",
                icon: 'icon-view-bookings',
                url: '/account/bookings',
                module: 'bookings',
                view: 'views/viewbooking.html',
                seoDetails: {
                    title: 'View Bookings: View your past and upcoming bus bookings | Travelyaari'
                }
            }, {
                title: "View Loyalty Points",
                icon: 'icon-loyalty-points',
                url: '/account/privilege-card',
                view: 'views/privilegecard.html',
                module: 'privilege-card',
                target: '',
                seoDetails: {
                    title: 'View Loyalty Points: View your loyalty points and avial them by booking bus tickets | Travelyaari'
                }
            }, {
                title: "Check Refund Status",
                icon: 'icon-refund-status',
                url: '/account/refund',
                view: 'views/refundstatus.html',
                module: 'refund',
                seoDetails: {
                    title: 'Check Refund Status: Check the refund status of your cancelled ticket | Travelyaari'
                }
            }, {
                title: "Change Password",
                icon: 'icon-change-password',
                url: '/account/change-password',
                module: 'change-password',
                view: 'views/changepassword.html',
                seoDetails: {
                    title: 'Change Password: Change the password for the security reasons | Travelyaari'
                }
            }, ],
            'accountDetails': {
                data: {},
                error: true
            },
            'loyaltyDetails': {
                data: {},
                error: true
            },
            'bookingList': {
                data: {
                    'all': {},
                    'bus': [],
                    'hotel': [],
                    'tour': [],
                    'activity': []
                },
                error: true
            },
            'selectedBooking': {
                card: {},
                data: {},
                error: true
            },
            'pageSlider': 0,
            'isProcessing': false,
            'errorMessages': {
                'loadingMsg': "Loadling...",
                'emptyMsg': "Loadling...",
            },
            'dateFormat': 'dd/MM/yyyy',
            'datePickerDobOpen': false,
            'datePickerDobOptions': {
                'dateDisabled': false,
                'formatYear': 'dd/MM/yyyy',
                'maxDate': new Date(),
                'minDate': new Date('1900/01/01'),
                'startingDay': 0,
                'showWeeks': false,
                'label': "dob",
                'uniqueName': "dob",
                // 'minMode': 'month'
            },
            'busSeatsToCancel': {},
            'message': "",
            'error': ""
        };

        return accountData;
    }]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.accountService
 * @description
 * # accountService
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('accountService', ['CONSTANTS', '$rootScope', '$q', '$http', 'accountData',
        function(CONSTANTS, $rootScope, $q, $http, accountData) {
            var accountService = {
                getAccountDetails: getAccountDetailsFn,
                getLoyaltyDetails: getLoyaltyDetailsFn,
                uploadProfielImage: uploadProfielImageFn,
                saveProfile: saveProfileFn,

                changePassword: changePasswordFn,

                getBookingDetails: getBookingDetailsFn,
                getOrderDetails: getOrderDetailsFn,
                getPassenegerDetails: getPassenegerDetailsFn,

                smsBusTicket: smsBusTicketFn,
                smsBooking: smsBookingFn,
                emailTicket: emailTicketFn,

                busRefundStatus: busRefundStatusFn,
                hotelRefundStatus: hotelRefundStatusFn,

                busCancelDetails: busCancelDetailsFn,
                tourCancelDetails: tourCancelDetailsFn,
                hotelCancelDetails: hotelCancelDetailsFn,

                cancelBus: cancelBusFn,
                cancelTour: cancelTourHotelFn,
                cancelHotel: cancelTourHotelFn,

                getBusBookingDetailsFromGds: getBusBookingDetailsFromGdsFn,
                getCancelationChargesFromTY: getCancelationChargesFromTYFn
            };

            function getAccountDetailsFn(isFromCache) {
                var deferred = $q.defer(),
                    isFromCache = isFromCache === undefined ? true : isFromCache,
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': isFromCache,
                    'url': baseUrl + '/api/account/profile',
                    'method': 'GET'
                }).then(function(response) {
                        if (response.data.success) {
                            accountData.accountDetails.error = false;
                            accountData.accountDetails.data = response.data.data;
                            var dob = accountData.accountDetails.data.dob.split('/');
                            accountData.accountDetails.data.dob = {};
                            if (accountData.accountDetails.data.dob) {
                                accountData.accountDetails.data.dob.dd = dob[0];
                                accountData.accountDetails.data.dob.mm = dob[1];
                                accountData.accountDetails.data.dob.yyyy = dob[2];
                            }
                        } else {
                            accountData.accountDetails.error = true;
                        }
                        deferred.resolve(response);
                    },
                    function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            function getLoyaltyDetailsFn(isFromCached) {
                var deferred = $q.defer(),
                    isFromCached = isFromCached === undefined ? true : isFromCached,
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': isFromCached,
                    'url': baseUrl + '/api/account/loyalty',
                    'method': 'GET'
                }).then(function(response) {
                        if (response.data.success) {
                            accountData.loyaltyDetails.error = false;
                            response.data.data.tpcn = response.data.data.tpcn.match(/.{1,4}/g).join(" ");
                            accountData.loyaltyDetails.data = response.data.data;
                            deferred.resolve(response);
                        } else {
                            accountData.accountDetails.error = true;
                        }

                    },
                    function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            function saveProfileFn(postData) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/account/saveProfile',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(obj) {
                        var str = [];
                        for (var p in obj) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        }
                        return str.join("&");
                    }
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.accountDetails.error = false;
                        accountData.accountDetails.data = response.data.data;
                        var dob = accountData.accountDetails.data.dob.split('/');
                        accountData.accountDetails.data.dob = {};
                        if (accountData.accountDetails.data.dob) {
                            accountData.accountDetails.data.dob.dd = dob[0];
                            accountData.accountDetails.data.dob.mm = dob[1];
                            accountData.accountDetails.data.dob.yyyy = dob[2];
                        }
                    } else {
                        accountData.accountDetails.error = true;
                    }
                    deferred.resolve(response);
                }, function(err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            }

            function uploadProfielImageFn(file) {
                var deferred = $q.defer(),
                    fd = new FormData(),
                    baseUrl = CONSTANTS.API_URL;

                fd.append('file', file);

                $http.post(
                        baseUrl + '/api/account/uploadProfileImage',
                        fd, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined, 'Process-Data': false }
                        })
                    .then(function(response) {
                        deferred.resolve(response);
                    }, function(err) {
                        deferred.reject(err);
                    });
            }

            function changePasswordFn(postData) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/account/changePassword',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(obj) {
                        var str = [];
                        for (var p in obj) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        }
                        return str.join("&");
                    }
                }).then(function(response) {
                    deferred.resolve(response);
                }, function(err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            }

            function getBookingDetailsFn(isFromCached) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL,
                    isFromCached = isFromCached === undefined ? true : isFromCached;

                accountData.isProcessing = true;
                $http({
                    'cache': isFromCached,
                    'url': baseUrl + '/api/account/bookings?v=' + Date.now(),
                    // 'url': 'https://demo7819630.mockable.io/api/account/bookings/email/somnath.sinha@travelyaari.com/649037',
                    'method': 'GET'
                }).then(function(response) {
                        if (response.status === 200 && response.data.success) {
                            accountData.bookingList.error = false;
                            accountData.bookingList.data.all = response.data.response;

                            accountData.bookingList.data.bus = [];
                            accountData.bookingList.data.hotel = [];
                            accountData.bookingList.data.tour = [];
                            accountData.bookingList.data.activity = [];
                            response.data.response.forEach(function(data) {
                                accountData.bookingList.data[data.vertical].push(data);
                            });

                            deferred.resolve(response);
                        } else {
                            accountData.bookingList.error = true;
                        }
                        accountData.isProcessing = false;

                    },
                    function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            function getOrderDetailsFn(orderId) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/transactions/bookingDetails/' + orderId,
                    'method': 'GET'
                }).then(function(response) {
                    accountData.selectedBooking.error = false;
                    accountData.selectedBooking.data = response.data;
                    if (response.data.booking.order.type == 1) {
                        busCancelDetailsFn(accountData.selectedBooking.data.booking.order.bus_booking.onwards.pnr, accountData.selectedBooking.data.booking.order.bus_booking.onwards.ticketNo)
                    } else if (response.data.booking.order.type == 2) {
                        hotelCancelDetailsFn(accountData.selectedBooking.data.booking.order.hotel_booking.booking_id, accountData.selectedBooking.data.booking.customer_details.email)
                    } else if (response.data.booking.order.type == 3) {
                        tourCancelDetailsFn(accountData.selectedBooking.data.booking.order.tour_booking.booking_id, accountData.selectedBooking.data.booking.customer_details.email)
                    }

                    deferred.resolve(response);
                }, function(err) {
                    deferred.resolve(err);
                });

                return deferred.promise;
            }

            function getPassenegerDetailsFn(orderId) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/transactions/paxDetails/' + orderId,
                    'method': 'GET'
                }).then(function(response) {
                    // accountData.selectedBooking.error = false;
                    accountData.selectedBooking.data.paxDetails = response.data.data.pax;
                    deferred.resolve(response);
                }).catch(function(err) {
                    deferred.resolve(err);
                });

                return deferred.promise;
            }

            function smsBusTicketFn(postData) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/ticket/smsbus/',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(postParams) {
                        var str = [];
                        for (var param in postParams) {
                            str.push(encodeURIComponent(param) + "=" + encodeURIComponent(postParams[param]));
                        }
                        return str.join("&");
                    }
                }).then(function(response) {
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function emailTicketFn(postData) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/ticket/sendBookingEmail/',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(postParams) {
                        var str = [];
                        for (var param in postParams) {
                            str.push(encodeURIComponent(param) + "=" + encodeURIComponent(postParams[param]));
                        }
                        return str.join("&");
                    }
                }).then(function(response) {
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function smsBookingFn(postData) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/transactions/sendsms/',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(postParams) {
                        var str = [];
                        for (var param in postParams) {
                            str.push(encodeURIComponent(param) + "=" + encodeURIComponent(postParams[param]));
                        }
                        return str.join("&");
                    }
                }).then(function(response) {
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function busRefundStatusFn(pnr, ticketNo) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/ticket/refund/' + pnr + '/' + ticketNo,
                    'method': 'GET'
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.refundDetails = response.data.data.refundDetails;
                    } else {
                        accountData.selectedBooking.refundDetails = {};
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function hotelRefundStatusFn(bookingId, email) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/transactions/refundHotel/' + bookingId + '/' + email,
                    'method': 'GET'
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.refundDetails = response.data.output;
                    } else {
                        accountData.selectedBooking.refundDetails = {};
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function busCancelDetailsFn(pnr, ticketNo) {

                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/ticket/details/' + pnr + '/' + ticketNo,
                    'method': 'GET'
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.data.isCancelled = response.data.isCancelled;
                        accountData.selectedBooking.data.ticketDetails = response.data.ticketDetails;
                    } else {
                        accountData.selectedBooking.data.ticketDetails = {};
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function tourCancelDetailsFn(bookingId, email) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/transactions/cancelDetails/tour/' + bookingId + '/' + email,
                    'method': 'GET'
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.data.packageDetails = response.data.details;
                    } else {
                        accountData.selectedBooking.data.packageDetails = {};
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function hotelCancelDetailsFn(bookingId, email) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v2/transactions/cancelDetails/hotel/' + bookingId + '/' + email,
                    'method': 'GET'
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.data.hotelDetails = response.data.details;
                    } else {
                        accountData.selectedBooking.data.hotelDetails = {};
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function cancelBusFn(postData) {
                var deferred = $q.defer();

                $http({
                    'cache': false,
                    'url': CONSTANTS.API_URL + '/api/v3/ticket/cancel',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(obj) {
                        var str = [];
                        for (var p in obj) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        }
                        return str.join("&");
                    }
                }).then(function(data) {
                    deferred.resolve(data);
                });

                return deferred.promise;
            }

            function cancelTourHotelFn(postData) {
                var deferred = $q.defer();
                $http({
                    'cache': false,
                    'url': url + '/api/v2/transactions/cancel',
                    'method': 'POST',
                    'data': postData,
                    'headers': { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                    'transformRequest': function(obj) {
                        var str = [];
                        for (var p in obj) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        }
                        return str.join("&");
                    }
                }).then(function(data) {
                    deferred.resolve(data);
                });

                return deferred.promise;
            }

            function getBusBookingDetailsFromGdsFn(pnr, ticketNo) {
                var deferred = $q.defer();
                $http({
                    'cache': true,
                    'url': CONSTANTS.GDS_TRANS_API_URL + '/api/bookingdetails/?PNR=' + pnr + '&TicketNo=' + ticketNo,
                    'method': 'POST',
                    'headers': { 
                        'access-token': CONSTANTS.GDS_TOKEN
                    }
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.data = response.data.data;

                        if (!response.data.data.IsNewBooking) {
                            getCancelationChargesFromTYFn(response.data.data.RouteScheduleId)
                        }
                    } else {
                        accountData.selectedBooking.data = {};
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            function getCancelationChargesFromTYFn(rsId) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;

                $http({
                    'cache': true,
                    'url': baseUrl + '/api/v3/ticket/cancelationCharges/' + rsId,
                    'method': 'GET'
                }).then(function(response) {
                    if (response.data.success) {
                        accountData.selectedBooking.data.Cancellations = response.data.response;
                    }
                    deferred.resolve(response);
                });

                return deferred.promise;
            }

            return accountService;
        }

    ]);

'use strict';

/**
 * @ngdoc function
 * @name ngBusApp.controller:BookingdetailsCtrl
 * @description
 * # BookingdetailsCtrl
 * Controller of the ngBusApp
 */
angular.module('ngBusApp')
    .controller('BookingDetailsCtrl', ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService', 'userVerificationService', 'userVerificationData',
        function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService, userVerificationService, userVerificationData) {
            function setSelectedBookingObjectFn(token) {
                var obj = {},
                    currentTs = (new Date()).getTime(),
                    ts,
                    arrivalTs,
                    departureTs;
                if (token.indexOf('rnpyt-') !== -1) {
                    arrivalTs = (new Date(accountData.selectedBooking.data.ArrivalDateTime)).getTime();
                    departureTs = (new Date(accountData.selectedBooking.data.DepartureDateTime)).getTime();

                    obj = {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                        vertical: "bus",
                        frm: accountData.selectedBooking.data.FromCityName,
                        to: accountData.selectedBooking.data.ToCityName,
                        pickup: accountData.selectedBooking.data.PickupInfo.PickupName,
                        drop: accountData.selectedBooking.data.ToCityName,
                        doj: accountData.selectedBooking.data.JourneyDate,
                        hotelName: "",
                        checkInDate: "",
                        checkOutDate: "",
                        packageName: "",
                        numDays: "",
                        paxCount: "",
                        isCancelled: accountData.selectedBooking.data.IsCancelled,
                        token: '',
                        orderId: '',
                        isPrevious: arrivalTs <= currentTs,
                        isCancellable: departureTs > currentTs,
                        viewType: $scope.viewType,
                        urlType: $scope.urlType
                    }


                    /*if ($routeParams.viewType === "refund") {
                        accountData.isProcessing = true;
                        accountService.busRefundStatus(accountData.selectedBooking.data.booking.order.bus_booking.onwards.pnr, accountData.selectedBooking.data.booking.order.bus_booking.onwards.ticketNo).then(function(response) {
                            accountData.isProcessing = false;
                        });
                    }*/
                } else if (accountData.selectedBooking.data.booking.order.type == 2) {
                    ts = (new Date(accountData.selectedBooking.data.booking.order.hotel_booking.checkin_date)).getTime();
                    obj = {
                        vertical: "hotel",
                        frm: "",
                        to: "",
                        pickup: "",
                        drop: "",
                        doj: "",
                        hotelName: accountData.selectedBooking.data.booking.order.hotel_booking.hotel_name,
                        checkInDate: accountData.selectedBooking.data.booking.order.hotel_booking.checkin_date,
                        checkOutDate: accountData.selectedBooking.data.booking.order.hotel_booking.checkout_date,
                        packageName: "",
                        numDays: "",
                        paxCount: "",
                        isCancelled: $scope.viewType == 'refund' ? true : false,
                        // applicableDate: 1475778600,
                        token: token,
                        orderId: accountData.selectedBooking.data.booking.order.id,
                        isPrevious: ts <= currentTs,
                        isCancellable: ts > currentTs,
                        viewType: $scope.viewType,
                        urlType: $scope.urlType
                    }

                    if ($routeParams.viewType === "refund") {
                        accountData.isProcessing = true;
                        accountService.hotelRefundStatus(accountData.selectedBooking.data.booking.order.id, accountData.selectedBooking.data.booking.customer_details.email).then(function(response) {
                            accountData.isProcessing = false;
                        });
                    }
                } else if (accountData.selectedBooking.data.booking.order.type == 3) {
                    ts = (new Date(accountData.selectedBooking.data.booking.order.tour_booking.journeyDate)).getTime();
                    obj = {
                        vertical: accountData.selectedBooking.data.booking.order.package_type,
                        frm: "",
                        to: "",
                        pickup: "",
                        drop: "",
                        doj: accountData.selectedBooking.data.booking.order.tour_booking.journeyDate,
                        hotelName: "",
                        checkInDate: "",
                        checkOutDate: "",
                        packageName: accountData.selectedBooking.data.booking.order.tour_booking.packageName,
                        numDays: accountData.selectedBooking.data.booking.order.tour_booking.days,
                        paxCount: accountData.selectedBooking.data.booking.order.tour_booking.count,
                        isCancelled: $scope.viewType == 'refund' ? true : false,
                        // applicableDate: 1475778600,
                        token: token,
                        orderId: accountData.selectedBooking.data.booking.order.id,
                        isPrevious: ts <= currentTs,
                        isCancellable: ts > currentTs,
                        viewType: $scope.viewType,
                        urlType: $scope.urlType
                    }
                }

                accountData.selectedBooking.card = obj;
            }

            function getDetailsDataFn(token) {

                accountData.selectedBooking = {
                    card: {},
                    data: {},
                    error: true
                };
                if (token.indexOf('rnpyt-') === -1) {
                    accountData.isProcessing = true;
                    accountService.getOrderDetails(token).then(function(response) {
                        setSelectedBookingObjectFn(token);
                        accountData.isProcessing = false;
                    });
                } else {
                    var bookingData = atob(token.split('_')[1].replace('rnpyt-', '')).split('|');
                    accountData.isProcessing = true;
                    // accountService.getBusBookingDetailsFromGds('89166910-31540',   '33317188718').then(function(response) {
                    accountService.getBusBookingDetailsFromGds(bookingData[0], bookingData[1]).then(function(response) {
                        setSelectedBookingObjectFn(token);
                        accountData.isProcessing = false;
                    });
                }
            }

            function initFn() {
                $rootScope.header.title = $routeParams.viewType === "refund" ? "Refund Status" : "Itinerary Details";
                $rootScope.footer.show = true;
                $scope.currentModule = $routeParams.viewType === "refund" ? "refund" : "bookings";
                $scope.viewType = $routeParams.viewType;
                $scope.urlType = $routeParams.urlType;

                if ($scope.urlType == "account") {
                    accountData.isProcessing = true;
                    accountService.getLoyaltyDetails(false).then(function(response) {
                        accountData.isProcessing = false;
                    });
                    getDetailsDataFn($routeParams.token);
                    $scope.accountData = accountData;
                }

                if ($scope.urlType == "user") {
                    getDetailsDataFn($routeParams.token);
                    $scope.accountData = accountData;
                    $scope.accountData.accountOptions = userVerificationData.userOptions;
                }

                $rootScope.metaProperties.data.title = 'Print | SMS | Email | Cancel Booking | Refund Status | Travelyaari';
                $rootScope.metaProperties.data.url = $location.$$url;

            }

            initFn();
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyFixedOnScroll
 * @description
 * # tyFixedOnScroll
 */
angular.module('ngBusApp')
    .directive('tyFixedOnScroll', ['$window',
        function($window) {
            return {
                restrict: 'A',
                link: function postLink(scope, element, attrs) {
                    var eleTopPosition,
                        newEleTopPosition,
                        isLess = true,
                        $el = element[0],
                        pageYOffset = $window.pageYOffset || document.documentElement.scrollTop,
                        eleWidth = $el.offsetWidth;

                    function setElemTopPositionVarFn(topPos) {
                        if (attrs.tyFixedOnScroll == '') {
                            eleTopPosition = topPos;
                        } else {
                            eleTopPosition = attrs.tyFixedOnScroll;
                        }
                    }

                    function fixElementFn() {
                        pageYOffset = $window.pageYOffset || document.documentElement.scrollTop;
                        if (pageYOffset !== 0 && pageYOffset >= eleTopPosition) {
                            if (isLess) {
                                element.addClass('ty-fixed-on-scroll');
                                element.css('width', eleWidth + 'px');

                            }
                            isLess = false;
                        } else {
                            if (!isLess) {
                                element.removeClass('ty-fixed-on-scroll');
                            }
                            isLess = true;
                        }

                        if (isLess) {
                            newEleTopPosition = $el.getBoundingClientRect().top + pageYOffset;
                            setElemTopPositionVarFn(eleTopPosition === newEleTopPosition && !isLess ? eleTopPosition : newEleTopPosition);
                        }

                    }

                    setElemTopPositionVarFn($el.getBoundingClientRect().top + pageYOffset);
                    angular.element($window).on('load', fixElementFn);
                    angular.element($window).on('scroll', fixElementFn);
                }
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyFbBenefitSwipe
 * @description
 * # tyFbBenefitSwipe
 */
angular.module('ngBusApp')
    .directive('tyFbBenefitSwipe', ['$rootScope', '$timeout',
        function($rootScope, $timeout) {
            return {
                restrict: 'A',
                controller: ['$scope', '$element',
                    function($scope, $element) {
                        var changeTrackerFn, touchX, touchY, endTouchX, endTouchY, pageChangeTimeoutId;

                        function setTrackerFn() {
                            $timeout(function() {
                                $rootScope.openModal();
                                $scope.showSlide = true;
                            });
                        }

                        $element[0].addEventListener('touchstart', function(e) {
                            changeTrackerFn = setTrackerFn;
                            for (var i = 0; i < e.changedTouches.length; i++) {
                                touchX = e.changedTouches[i].screenX;
                                touchY = e.changedTouches[i].screenY;
                            }
                        });

                        $element[0].addEventListener('touchmove', function(e) {
                            $timeout.cancel(pageChangeTimeoutId);
                            pageChangeTimeoutId = $timeout(function() {
                                changeTrackerFn = angular.noop;
                            }, 300);
                        });

                        $element[0].addEventListener('touchend', function(e) {
                            var diffX, diffY;
                            for (var i = 0; i < e.changedTouches.length; i++) {
                                endTouchX = e.changedTouches[i].screenX;
                                endTouchY = e.changedTouches[i].screenY;
                            }

                            diffX = touchX - endTouchX;
                            diffY = touchY - endTouchY;

                            if (Math.abs(diffX) < Math.abs(diffY) || Math.abs(diffX) < 50 || Math.abs(diffY) > 100) {
                                return;
                            }

                            if (diffX > 0) {
                                changeTrackerFn();
                            }
                        });
                    }
                ]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyFileModel
 * @description
 * # tyFileModel
 */
angular.module('ngBusApp')
    .directive('tyFileModel', ['$parse', function($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.tyFileModel);
                var modelSetter = model.assign;

                element.bind('change', function() {
                    scope.$apply(function() {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyProcessing
 * @description
 * # tyProcessing
 */
angular.module('ngBusApp')
    .directive('tyProcessing', function() {
        return {
            template: '<div class="ty-loader" ng-show="loading"><div class="ty-folding-cube"><div class="ty-cube1 ty-cube"></div><div class="ty-cube2 ty-cube"></div><div class="ty-cube4 ty-cube"></div><div class="ty-cube3 ty-cube"></div></div>' +
                '<div class="active-screen white-color"></div></div>',
            scope: {
                loading: '='
            },
            restrict: 'E',
            replace: true,
            link: function postLink(scope, element, attrs) {}
        };
    });

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyDateInput
 * @description
 * # tyDateInput
 */
angular.module('ngBusApp')
    .directive('tyDateInput', [function() {
        var i = 0,
            valid = false,
            currentDate = new Date(),
            obj = {};
        return {
            restrict: 'A',
            scope: {
                tyDateInput: '@'
            },
            link: function(scope, element, attrs) {
                var regex = new RegExp("^\\d+");
                ! function(i) {
                    element.bind('keyup', function(e) {
                        // console.log(typeof element[0].value)
                        if (regex.test(element[0].value)) {
                            switch (scope.tyDateInput) {
                                case 'dd':
                                    valid = /^(0?[1-9]|[1-2]?[0-9]|3[01])$/.test(element[0].value);
                                    break;
                                case 'mm':
                                    valid = /^(0?[1-9]|1?[0-2])$/.test(element[0].value);
                                    break;
                                case 'yyyy':
                                    valid = parseInt(element[0].value, 10) < currentDate.getFullYear() ? true : false;
                                    break;
                                default:
                                    valid = false;
                                    break;
                            }
                            if (!valid) {
                                element[0].value = element[0].value.slice(0, element[0].value.length - 1);
                            }
                            if (valid && (element[0].value.length == attrs.maxlength)) {
                                obj[i + 1] !== undefined ?
                                    obj[i + 1].focus() :
                                    obj[i].blur();
                            }
                        } else if (/[^\d]/g.test(element[0].value)) {
                            element[0].value = element[0].value.slice(0, element[0].value.length - 1);
                        }
                    });
                }(i);
                obj[i] = element[0];
                i++;
            }
        };
    }]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyCategoryPageHeader
 * @description
 * # tyCategoryPageHeader
 */
! function(window, angular, undefined) {
    angular.module('categorypage', ['categorypage.template'])
        .directive('categoryPageHeader', ['$timeout',
            function($timeout) {
                var prevTracker,
                    categoryPageHeader = {
                        templateUrl: "views/categorypageheader.html",
                        scope: {
                            'tracker': "="
                        },
                        restrict: 'E',
                        replace: true,
                        transclude: true,
                        controllerAs: "cPH",
                        controller: ['$scope', '$element',
                            function($scope, $element) {
                                var that = this,
                                    floorOrCeil, headerScrollId,
                                    element = $element[0],
                                    scrollElement = $element.find('div')[0];

                                function scrollLeftToFn(element, to, duration) {
                                    var difference = to - element.scrollLeft,
                                        perTick = difference / (duration || (function() {
                                            element.isScrolling = false;
                                            return 0.5;
                                        })()) * 10;

                                    floorOrCeil = perTick > 0 ? "ceil" : "floor";

                                    element.scrollLeft += Math[floorOrCeil](perTick);
                                    headerScrollId = $timeout(function() {
                                        if (element.scrollLeft === Math[floorOrCeil](to) ||
                                            Math.floor(element.scrollLeft) === 0 ||
                                            element.scrollLeft >= (element.scrollWidth - element.offsetWidth)) {
                                            element.isScrolling = false;
                                            return;
                                        }
                                        scrollLeftToFn(element, to, duration);
                                    }, 1, false);
                                }

                                function setDirFn() {
                                    var dir = prevTracker > $scope.tracker ? 'left' : 'right';
                                    $scope.elemSelectedSide = "categorypage-side-" + dir;
                                }

                                function animateScrollPosFn(scrollPos, dir) {
                                    $timeout.cancel(headerScrollId);
                                    scrollLeftToFn(scrollElement, scrollPos - element.offsetWidth / 2, 50);
                                }

                                function setScrollPosFn(scrollPos, dir) {
                                    $timeout.cancel(headerScrollId);
                                    $element.find('div')[0].scrollLeft = scrollPos - element.offsetWidth / 2;
                                }


                                function setTrackerFn(index) {
                                    $scope.tracker = index;
                                }

                                $scope.$watch('tracker', function(tracker) {
                                    setDirFn();
                                    that.scrollFunctions[tracker](tracker);
                                    prevTracker = that.tracker = tracker;
                                });

                                that.count = 0;
                                that.scrollFunctions = [];
                                that.isInitialized = false;
                                that.tracker = $scope.tracker;
                                that.scrollLeft = scrollElement.scrollLeft;
                                that.animateScrollPos = animateScrollPosFn;
                                that.setScrollPos = setScrollPosFn;
                                that.setTracker = setTrackerFn;

                                $scope.elemSelectedSide = "categorypage-side-right";
                            }
                        ]
                    };
                return categoryPageHeader;
            }
        ])
        .directive('categoryHeaderText', ['$timeout', '$location',
            function($timeout, $location) {
                var selectHeaderTimeoutId,
                    categoryHeaderText = {
                        templateUrl: "views/categoryheadertext.html",
                        scope: {
                            'active': "=?"
                        },
                        restrict: "E",
                        replace: true,
                        transclude: true,
                        require: "^categoryPageHeader",
                        controller: ['$scope', function($scope) {

                        }],
                        link: function(scope, element, attrs, categoryPageHeaderCtrl) {
                            var clientBoundRect = element[0].getBoundingClientRect(),
                                scrollLeftPos = Math.abs(clientBoundRect.left) + categoryPageHeaderCtrl.scrollLeft,
                                middleScrollPos = scrollLeftPos + clientBoundRect.width / 2;

                            function selectHeaderFn(e) {
                                $timeout(function() {
                                    categoryPageHeaderCtrl.setTracker(
                                        scope.index
                                    );
                                });
                            }

                            scope.cPHCtrl = categoryPageHeaderCtrl;
                            scope.index = categoryPageHeaderCtrl.count++;
                            categoryPageHeaderCtrl.scrollFunctions[scope.index] = function(tracker) {
                                categoryPageHeaderCtrl['animateScrollPos'](
                                    middleScrollPos
                                );
                            }

                            scope.selectHeader = selectHeaderFn;

                            element.bind('click', selectHeaderFn);

                            if (scope.active) {
                                $timeout(function() {
                                    categoryPageHeaderCtrl['setScrollPos'](
                                        middleScrollPos
                                    );
                                    scope.cPHCtrl.isInitialized = true;
                                }, 10, false);
                            }
                        }
                    };

                return categoryHeaderText;
            }
        ])
        .directive('categoryPageBody', ['$timeout',
            function($timeout) {
                var categoryPageBody = {
                    templateUrl: "views/categorypagebody.html",
                    scope: {
                        'tracker': "=",
                        'minusHeight': "=",
                        'getResults': "&",
                        'triggerAdjacentSlides': "=?"
                    },
                    replace: true,
                    transclude: true,
                    controllerAs: 'cPB',
                    controller: ['$scope', '$element',
                        function($scope, $element) {
                            var that = this,
                                pageChangeTimeoutId,
                                touchX, touchY, endTouchX, endTouchY, changeTrackerFn;

                            that.initialized = false;
                            that.count = 0;
                            that.tracker = $scope.tracker;
                            that.pageHeight = window.innerHeight - $scope.minusHeight;

                            function initializedFn() {
                                $timeout(function() {
                                    that.initialized = true;
                                }, 10, false);
                            }

                            function setTrackerFn(tracker) {
                                $timeout(function() {
                                    $scope.tracker = tracker;
                                });
                            }

                            function triggerAdjacentSlidesFn(adjacentTrackers) {
                                if (adjacentTrackers >= 0 && adjacentTrackers <= that.count) {
                                    $scope.getResults({ 'tracker': adjacentTrackers, 'current': false });
                                }
                            }

                            $scope.$watch('tracker', function(tracker) {
                                that.tracker = tracker;
                                $scope.getResults({ 'tracker': that.tracker, 'current': true });
                                if ($scope.triggerAdjacentSlides === true) {
                                    triggerAdjacentSlidesFn((that.tracker + 1));
                                    triggerAdjacentSlidesFn((that.tracker - 1));
                                }
                                $timeout(function() {
                                    window.requestAnimationFrame(function() {
                                        $element.find('div')[0].style.transform = 'translateX(-' + (tracker * 100) + '%)';
                                        initializedFn();
                                    });
                                }, 50, false);
                            });

                            $element[0].addEventListener('touchstart', function(e) {
                                changeTrackerFn = setTrackerFn;
                                for (var i = 0; i < e.changedTouches.length; i++) {
                                    touchX = e.changedTouches[i].screenX;
                                    touchY = e.changedTouches[i].screenY;
                                }
                            });

                            $element[0].addEventListener('touchmove', function(e) {
                                $timeout.cancel(pageChangeTimeoutId);
                                pageChangeTimeoutId = $timeout(function() {
                                    changeTrackerFn = angular.noop;
                                }, 300);
                            });

                            $element[0].addEventListener('touchend', function(e) {
                                var diffX, diffY, tracker;
                                for (var i = 0; i < e.changedTouches.length; i++) {
                                    endTouchX = e.changedTouches[i].screenX;
                                    endTouchY = e.changedTouches[i].screenY;
                                }

                                diffX = touchX - endTouchX;
                                diffY = touchY - endTouchY;

                                if (Math.abs(diffX) < Math.abs(diffY) || Math.abs(diffX) < 50 || Math.abs(diffY) > 100) {
                                    return;
                                }

                                tracker = that.tracker + (diffX > 0 ? 1 : -1);
                                if (tracker >= 0 && tracker < that.count) {
                                    changeTrackerFn(tracker);
                                }
                            });
                        }
                    ]
                };

                return categoryPageBody;
            }
        ])
        .directive('categoryBodyContent', [function() {
            var categoryBodyContent = {
                scope: true,
                templateUrl: "views/categorybodycontent.html",
                replace: true,
                transclude: true,
                require: "^categoryPageBody",
                link: function(scope, element, attrs, categoryPageBodyCtrl) {
                    scope.cPBCtrl = categoryPageBodyCtrl;
                    scope.index = categoryPageBodyCtrl.count++;
                }
            };

            return categoryBodyContent;
        }]);

    angular.module('categorypage.template', []).run(['$templateCache',
        function($templateCache) {
            $templateCache.put('views/categorypageheader.html',
                "<div class=\"categorypage\">" +
                "   <div class='categorypage-header {{elemSelectedSide}}'" +
                "       ng-class=\"{'is-initialized':cPH.isInitialized}\"" +
                "       ng-transclude></div>" +
                "</div>" +
                "");

            $templateCache.put('views/categoryheadertext.html',
                "<a class='categorypage-text'" +
                "   ng-class=\"{'active':cPHCtrl.tracker===index}\"" +
                "   ng-transclude>" +
                "</a>" +
                "");

            $templateCache.put('views/categorypagebody.html',
                "<div class='categorypage-body'>" +
                "   <div" +
                "       ng-class=\"{'is-initialized':cPB.initialized}\"" +
                "       ng-transclude>" +
                "   </div>" +
                "</div>" +
                "");

            $templateCache.put('views/categorybodycontent.html',
                "<div class='categorypage-content'" +
                "   ng-class=\"{'active':cPBCtrl.tracker===index}\"" +
                "   ng-style=\"{'height':cPBCtrl.pageHeight+'px'}\"" +
                "   ng-transclude>" +
                "</div>" +
                "")
        }
    ])
}(window, angular);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyBookingResults
 * @description
 * # tyBookingResults
 */
angular.module('ngBusApp')
    .directive('tyBookingResults', ['$location', 'accountData',
        function($location, accountData) {
            return {
                scope: true,
                replace: true,
                restrict: 'A',
                controller: ['$scope', '$attrs', function($scope, $attrs) {
                    
                }]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyBookingCard
 * @description
 * # tyBookingCard
 */
angular.module('ngBusApp')
    .directive('tyBookingCard', ['$location', 'accountData',
        function($location, accountData) {
            return {
                templateUrl: "views/tybookingcard.html",
                scope: {
                    'bookingData': "=",
                    'viewType': "=",
                    'urlType': "="
                },
                replace: true,
                restrict: 'E',
                controller: ['$scope', '$attrs', 'accountData', function($scope, $attrs, accountData) {
                    function isClickableFn(isDisabled, event) {
                        if ($scope.viewType !== 'refund') {
                            isDisabled && event.preventDefault();
                        }
                    }

                    function isDisabledFn() {
                        return ($scope.viewType !== 'refund' || accountData.selectedBooking.data.isCancelled);
                    }

                    /*if($scope.bookingData.isCancelled){
                        $scope.viewType = 'refund';
                    }*/

                    $scope.isClickable = isClickableFn;
                    $scope.isDisabled = isDisabledFn;
                    $scope.accountData = accountData;
                }]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyBusBookingDetails
 * @description
 * # tyBusBookingDetails
 */
angular.module('ngBusApp')
    .directive('tyBusBookingDetails', ['$location', '$timeout', 'accountData', 'accountService', 'printTicketService',
        function($location, $timeout, accountData, accountService, printTicketService) {
            return {
                templateUrl: "views/tybusbookingdetails.html",
                scope: true,
                replace: true,
                restrict: 'E',
                controller: ['$scope', '$attrs', '$timeout', function($scope, $attrs, $timeout) {
                    function emailTicketFn(ticketNo, pnrNo, emailId) {
                        var postData = {
                            vertical: 'bus',
                            ticketNo: ticketNo,
                            pnrNo: pnrNo,
                            emailAddress: emailId
                        };

                        accountData.isProcessing = true;
                        accountService.emailTicket(postData).then(function(response) {
                            accountData.isProcessing = false;
                            if (response.data.success) {
                                $scope.message = response.data.data.message;
                                $scope.error = false;
                            } else {
                                $scope.message = response.data.error.message;
                                $scope.error = true;
                            }
                        });
                    }

                    function smsTicketFn(ticketNo, pnrNo, mobileNo) {

                        if (!mobileNo) {
                            mobileNo = prompt("No mobile number for this booking. Please enter mobile number");
                        }

                        var postData = {
                            ticketNo: ticketNo,
                            pnrNo: pnrNo,
                            mobileNo: mobileNo
                        };

                        accountData.isProcessing = true;
                        accountService.smsBusTicket(postData).then(function(response) {
                            accountData.isProcessing = false;
                            if (response.data.success) {
                                $scope.message = 'SMS sent successfully';
                                $scope.error = false;
                            } else {
                                $scope.message = response.data.error.message;
                                $scope.error = true;
                            }

                        });
                    }

                    function confirmCancelTicketFn() {
                        $scope.isCancelInitiated = true;
                    }

                    function cancelTicketFn(ticketNo, pnrNo, emailId) {
                        var seatsToCancel = [],
                            errorMsg = "",
                            rdrUrl = "";

                        if (document.URL.indexOf('user/booking') !== -1) {
                            rdrUrl = "/user/bookings";
                        } else {
                            rdrUrl = "/account/bookings";
                        }

                        $scope.message = "";
                        $scope.error = false;

                        for (var seat in accountData.busSeatsToCancel) {
                            if (accountData.busSeatsToCancel.hasOwnProperty(seat) && accountData.busSeatsToCancel[seat]) {
                                seatsToCancel.push(seat);
                            }
                        }

                        var seatNos = seatsToCancel.toString();
                        if (seatNos !== '') {
                            var postData = {
                                PNR: pnrNo,
                                TicketNo: ticketNo,
                                SeatNos: seatsToCancel.toString()
                            };

                            accountData.isProcessing = true;
                            accountService.cancelBus(postData).then(function(response) {
                                if (response.data.success) {
                                    $scope.message = "Refund of is Rs. " + response.data.data.RefundAmount + " is processed";
                                    $scope.error = false;
                                    $timeout(function() {
                                        $location.path(rdrUrl);
                                    }, 3000);
                                } else {
                                    $scope.message = response.data.error;
                                    $scope.error = true;
                                    $timeout(function() {
                                        $location.path(rdrUrl);
                                    }, 3000);

                                }

                                accountData.isProcessing = false;
                            });
                        } else {
                            $scope.message = "Please select a seat";
                            $scope.error = true;
                        }
                    }

                    function refundStatusFn(ticketNo, pnrNo, emailId) {
                        accountData.isProcessing = true;
                        accountService.busRefundStatus(pnrNo, ticketNo).then(function(response) {
                            accountData.isProcessing = false;
                        });
                    }

                    function printTicketFn(ticketNo, pnr) {
                        printTicketService.printBusTicket(pnr, ticketNo);
                    }

                    function proccedToCancelTicketFn() {

                        var seatsToCancel = [];

                        for (var seat in accountData.busSeatsToCancel) {
                            if (accountData.busSeatsToCancel.hasOwnProperty(seat) && accountData.busSeatsToCancel[seat]) {
                                seatsToCancel.push(seat);
                            }
                        }

                        if (seatsToCancel.toString() !== '') {
                            $scope.reasonPage = true;
                        } else {
                            $scope.message = "Please select a seat to cancel";
                            $scope.error = true;
                        }
                    }

                    accountData.busSeatsToCancel = {};
                    $scope.emailTicket = emailTicketFn;
                    $scope.smsTicket = smsTicketFn;
                    $scope.cancelTicket = cancelTicketFn;
                    $scope.refundStatus = refundStatusFn;
                    $scope.printTicket = printTicketFn;
                    $scope.confirmCancelTicket = confirmCancelTicketFn;
                    $scope.proccedToCancelTicket = proccedToCancelTicketFn;
                    $scope.viewType = accountData.selectedBooking.card.viewType;
                    $scope.urlType = accountData.selectedBooking.card.urlType;
                    $scope.isCancelInitiated = false;
                    $scope.reasonPage = false;

                    $scope.$watch('message', function() {
                        if ($scope.message) {
                            $timeout(function() {
                                $scope.message = "";
                                $scope.error = false;
                            }, 5000);
                        }
                    });

                    $scope.accountData = accountData;
                }]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyTourBookingDetails
 * @description
 * # tyTourBookingDetails
 */
angular.module('ngBusApp')
    .directive('tyTourBookingDetails', ['$location', 'accountData', 'accountService', 'printTicketService',
        function($location, accountData, accountService, printTicketService) {
            return {
                templateUrl: "views/tytourbookingdetails.html",
                scope: true,
                replace: true,
                restrict: 'E',
                controller: ['$scope', '$attrs', function($scope, $attrs) {
                    function emailTicketFn(orderId) {
                        var postData = {
                            vertical: 'tour',
                            orderId: orderId
                        };
                        accountData.isProcessing = true;
                        accountService.emailTicket(postData).then(function(response) {
                            accountData.isProcessing = false;
                            if (response.data) {
                                $scope.message = "Email sent successfully";
                                $scope.error = false;
                            } else {
                                $scope.message = "Something went wrong. Please try later";
                                $scope.error = true;
                            }
                        });
                    }

                    function smsTicketFn(orderId, emailAddrs, mobileNo) {
                        var postData = {
                            type: 'tour',
                            bookingId: orderId,
                            emailId: emailAddrs,
                            mobileNo: mobileNo
                        };
                        accountData.isProcessing = true;
                        accountService.smsBooking(postData).then(function(response) {
                            accountData.isProcessing = false;
                            if (response.data.success) {
                                $scope.message = response.data.data.message;
                                $scope.error = false;
                            } else {
                                $scope.message = response.data.error.message;
                                $scope.error = true;
                            }
                        });

                    }

                    function cancelTicketFn(orderId, emailAddrs) {
                        var postData = {
                            type: 'tour',
                            invoiceNo: orderId,
                            email: emailAddrs
                        };

                        accountService.cancelTour(postData).then(function(response) {
                            if (response.data.success) {
                                $scope.message = "Booking cancelled successfully";
                                $scope.error = false;
                            } else {
                                if (response.data.error == null) {
                                    $scope.message = 'There was some error while processing your request. Please try again later.';
                                } else {
                                    $scope.message = response.data.error;
                                }
                                $scope.error = true;
                            }
                        });
                    }

                    function confirmCancelTicketFn() {
                        $scope.isCancelInitiated = true;
                    }

                    function printTicketFn(orderId) {
                        printTicketService.printPackageTicket(orderId);
                    }

                    function proccedToCancelTicketFn() {
                        $scope.reasonPage = true;
                    }

                    $scope.emailTicket = emailTicketFn;
                    $scope.smsTicket = smsTicketFn;
                    $scope.cancelTicket = cancelTicketFn;
                    $scope.printTicket = printTicketFn;
                    $scope.confirmCancelTicket = confirmCancelTicketFn;
                    $scope.proccedToCancelTicket = proccedToCancelTicketFn;

                    $scope.viewType = accountData.selectedBooking.card.viewType;
                    $scope.urlType = accountData.selectedBooking.card.urlType;
                }]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyHotelBookingDetails
 * @description
 * # tyHotelBookingDetails
 */
angular.module('ngBusApp')
    .directive('tyHotelBookingDetails', ['$location', 'accountData', 'accountService', 'printTicketService',
        function($location, accountData, accountService, printTicketService) {
            return {
                templateUrl: "views/tyhotelbookingdetails.html",
                scope: true,
                replace: true,
                restrict: 'E',
                controller: ['$scope', '$attrs', function($scope, $attrs) {
                    function emailTicketFn(orderId) {
                        var postData = {
                            vertical: 'hotel',
                            orderId: orderId
                        };
                        accountData.isProcessing = true;
                        accountService.emailTicket(postData).then(function(response) {
                            accountData.isProcessing = false;
                            if (response.data) {
                                $scope.message = 'Email sent successfully';
                                $scope.error = false;
                            } else {
                                $scope.message = 'Something went wrong. Please try later';
                                $scope.error = true;
                            }
                        });
                    }

                    function smsTicketFn(orderId, emailAddrs, mobileNo) {
                        if (!mobileNo) {
                            mobileNo = prompt("No mobile number for this booking. Please enter mobile number");
                        }
                        var postData = {
                            type: 'hotel',
                            bookingId: orderId,
                            emailId: emailAddrs,
                            mobileNo: mobileNo
                        };
                        accountData.isProcessing = true;
                        accountService.smsBooking(postData).then(function(response) {
                            accountData.isProcessing = false;
                            if (response.data.success) {
                                $scope.message = response.data.data.message;
                                $scope.error = false;
                            } else {
                                $scope.message = response.data.error.message;
                                $scope.error = true;
                            }
                        });

                    }

                    function refundStatusFn(orderId, emailAddrs) {
                        accountData.isProcessing = true;
                        accountService.hotelRefundStatus(orderId, emailAddrs).then(function(response) {
                            accountData.isProcessing = false;
                        });
                    }

                    function strToDateFn(dateStr) {
                        if (dateStr) {
                            var date = dateStr.split(" ");
                            return date[0];
                        }
                        return '';
                    }

                    function refundStatusMsgFn(refundStatus) {
                        var msg = "";
                        switch (refundStatus) {
                            case "NOT_CHECKED":
                                msg = "Cancellation Initiated";
                                break;
                            case "INIT_REFUND":
                                msg = "Refund Initiated";
                                break;
                            case "NOT_REFUNFED":
                                msg = "Refund not processed";
                                break;
                            default:
                                msg = "Not cancelled";
                        }

                        return msg;
                    }

                    function printTicketFn(orderId) {
                        printTicketService.printHotelTicket(orderId);
                    }

                    function cancelTicketFn(orderId, emailAddrs) {
                        var postData = {
                            type: 'hotel',
                            invoiceNo: orderId,
                            email: emailAddrs
                        };

                        accountData.isProcessing = true;
                        accountService.cancelHotel(postData).then(function(response) {
                            if (response.data.success) {
                                $scope.message = "Booking cancelled successfully";
                                $scope.error = false;
                            } else {
                                if (response.data.error == null) {
                                    $scope.message = 'There was some error while processing your request. Please try again later.';
                                } else {
                                    $scope.message = response.data.error;
                                }
                                $scope.error = true;
                                accountData.isProcessing = false;
                            }
                        });
                    }

                    function confirmCancelTicketFn() {
                        $scope.isCancelInitiated = true;
                    }

                    function proccedToCancelTicketFn() {
                        $scope.reasonPage = true;
                    }

                    function initFn() {
                        $scope.viewType = accountData.selectedBooking.card.viewType;
                        $scope.urlType = accountData.selectedBooking.card.urlType;
                    }

                    $scope.emailTicket = emailTicketFn;
                    $scope.smsTicket = smsTicketFn;
                    $scope.cancelTicket = cancelTicketFn;
                    $scope.refundStatus = refundStatusFn;
                    $scope.strToDate = strToDateFn;
                    $scope.refundStatusMsg = refundStatusMsgFn;
                    $scope.printTicket = printTicketFn;
                    $scope.confirmCancelTicket = confirmCancelTicketFn;
                    $scope.proccedToCancelTicket = proccedToCancelTicketFn;

                    initFn();
                }]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc function
 * @name ngBusApp.controller:VerifyuserCtrl
 * @description
 * # VerifyUserCtrl
 * Controller of the ngBusApp
 */
angular.module('ngBusApp')
    .controller('VerifyUserCtrl', ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', '$timeout', 'userVerificationService', 'userVerificationData', 'cookieService',
        function(CONSTANTS, $routeParams, $location, $rootScope, $scope, $timeout, userVerificationService, userVerificationData, cookieService) {

            function initFn() {
                $rootScope.footer.show = true;
                $scope.isContactInfo = false;
                $scope.showDelayedMsg = false;
                $scope.userVerificationData = userVerificationData;

                $rootScope.metaProperties.data.title = 'OTP: Helps you to cancel your ticket by generating an OTP without logging | Travelyaari';
                $rootScope.metaProperties.data.url = $location.$$url;
            }

            function getOtpFn() {
                var type, contactInfo;
                if ($scope.userVerify.$valid) {

                    if ($scope.otpEmail && $scope.otpEmail.length) {
                        type = 'email';
                        contactInfo = $scope.otpEmail;
                    }

                    if ($scope.otpMobile && $scope.otpMobile.length) {
                        type = 'mobile';
                        contactInfo = $scope.otpMobile;
                    }

                    $scope.isProcessing = true;
                    userVerificationService.sendOTP(type, contactInfo).then(function(response) {
                        if (response.data.success) {
                            $scope.isProcessing = false;
                            $scope.isContactInfo = true;
                            $timeout(function() {
                                $scope.showDelayedMsg = true;
                            }, 60 * 1000);
                        } else {
                            userVerificationData.message = userVerificationData.errorMsg;
                            userVerificationData.error = true;
                        }
                    });
                }
            }

            function verifyOtpFn(argument) {
                if ($scope.otpVerify.$valid) {
                    var type, contactInfo;
                    console.log(userVerificationData);

                    if (userVerificationData.userData.email !== '') {
                        type = 'email';
                        contactInfo = userVerificationData.userData.email;
                    }

                    if (userVerificationData.userData.mobile !== '') {
                        type = 'mobile';
                        contactInfo = userVerificationData.userData.mobile;
                    }

                    $scope.isProcessing = true;
                    userVerificationService.validateOTP(type, contactInfo, $scope.otp).then(function(response) {
                        $scope.isProcessing = false;

                        if (response.data.success) {
                            if (type === 'email') {
                                cookieService.createCookie('_uemail', contactInfo, 1);
                                cookieService.createCookie('_umobile', '', 1);
                            }
                            if (type === 'mobile') {
                                cookieService.createCookie('_uemail', '', 1);
                                cookieService.createCookie('_umobile', contactInfo, 1);
                            }
                            cookieService.createCookie('_uotp', $scope.otp, 1);

                            $location.path('/user/bookings');
                        } else {
                            userVerificationData.message = userVerificationData.errorMsg;
                            userVerificationData.error = true;
                        }
                    });
                }
            }

            $scope.getOtp = getOtpFn;
            $scope.verifyOtp = verifyOtpFn;

            initFn();

            $scope.$on('$locationChangeSuccess', function(next, current) {
                userVerificationData.message = '';
                userVerificationData.error = false;
            });
        }
    ]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.userVerificationService
 * @description
 * # userVerificationService
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('userVerificationService', ['CONSTANTS', '$rootScope', '$q', '$http', 'userVerificationData', 'accountData', 'cookieService',
        function(CONSTANTS, $rootScope, $q, $http, userVerificationData, accountData, cookieService) {
            var userVerificationService = {
                sendOTP: sendOTPFn,
                validateOTP: validateOTPFn,
                getBookingDetails: getBookingDetailsFn
            };

            function sendOTPFn(contactType, contactInfo) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': false,
                    'url': baseUrl + '/api/v2/account/generateOtp/' + contactType + '/' + contactInfo,
                    'method': 'POST'
                }).then(function(response) {
                        console.log(response)
                        if (response.data.success) {
                            userVerificationData.userData = response.data.response;
                        } else {
                            userVerificationData.error = true;
                            userVerificationData.errorMsg = response.data.error_msg;
                        }
                        deferred.resolve(response);
                    },
                    function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            function validateOTPFn(contactType, contactInfo, otp) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                $http({
                    'cache': false,
                    'url': baseUrl + '/api/v2/account/validateOtp/' + contactType + '/' + contactInfo + '/' + otp,
                    'method': 'POST'
                }).then(function(response) {
                        if (response.data.success) {
                            userVerificationData.userData = response.data.response;
                        } else {
                            userVerificationData.error = true;
                            userVerificationData.errorMsg = response.data.error_msg;
                        }
                        deferred.resolve(response);
                    },
                    function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            function getBookingDetailsFn(type, contactInfo, otp) {
                var deferred = $q.defer(),
                    baseUrl = CONSTANTS.API_URL;
                accountData.isProcessing = true;
                $http({
                    'cache': false,
                    'url': baseUrl + '/api/account/bookings/' + type + '/' + contactInfo + '/' + otp,
                    'method': 'GET'
                }).then(function(response) {
                        console.log(response);
                        if (response.status === 200 && response.data.success) {
                            accountData.bookingList.error = false;
                            accountData.bookingList.data.all = response.data.response;

                            accountData.bookingList.data.bus = [];
                            accountData.bookingList.data.hotel = [];
                            accountData.bookingList.data.tour = [];
                            accountData.bookingList.data.activity = [];
                            response.data.response.forEach(function(data) {
                                accountData.bookingList.data[data.vertical].push(data);
                            });

                            deferred.resolve(response);
                        } else {
                            if (!response.data.success && response.data.error_msg == "Invalid OTP") {
                                cookieService.eraseCookie('_uemail');
                                cookieService.eraseCookie('_umobile');
                                cookieService.eraseCookie('_uotp');
                                $location.path('/user/verify');
                            } else {
                                accountData.bookingList.error = true;
                            }
                        }
                        accountData.isProcessing = false;

                    },
                    function(err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }
            return userVerificationService;
        }

    ]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.userVerificationData
 * @description
 * # userVerificationData
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('userVerificationData', [function() {
        var userVerificationData = {
            'userOptions': [{
                title: "View My Bookings",
                icon: 'icon-view-bookings',
                url: '/user/bookings',
                module: 'bookings',
                view: 'views/viewbooking.html',
                seoDetails: {
                    title: 'View Bookings: View your past and upcoming bus bookings | Travelyaari'
                }
            }, {
                title: "Check Refund Status",
                icon: 'icon-refund-status',
                url: '/user/refund',
                view: 'views/refundstatus.html',
                module: 'refund',
                target: '',
                seoDetails: {
                    title: 'Check Refund Status: Check the refund status of your cancelled ticket | Travelyaari'
                }
            }],
            'userData': {
                email: '',
                mobile: '',
                remark: ''
            },
            error: false,
            errorMsg: '',
            message: '',
        };

        return userVerificationData;
    }]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.cookieService
 * @description
 * # cookieService
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('cookieService', function() {
        var cookieService = {
            createCookie: createCookieFn,
            readCookie: readCookieFn,
            eraseCookie: eraseCookieFn
        };

        function createCookieFn(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }

        function readCookieFn(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length);
                }

                if (c.indexOf(nameEQ) == 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            
            return null;
        }

        function eraseCookieFn(name) {
            createCookieFn(name, "", -1);
        }

        return cookieService;
    });

'use strict';

/**
 * @ngdoc function
 * @name ngBusApp.controller:UserBookingCtrl
 * @description
 * # UserBookingCtrl
 * Controller of the ngBusApp
 */
angular.module('ngBusApp')
    .controller('UserBookingCtrl', ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService', 'cookieService', 'userVerificationService', 'userVerificationData',
        function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService, cookieService, userVerificationService, userVerificationData) {

            function ifPageSliderMatchesFn(num) {
                return accountData.pageSlider === num;
            }

            function checkFilterFn(bookingObj) {

                var date = bookingObj.vertical == 'hotel' ? bookingObj.checkInDate : bookingObj.doj,
                    ts = (new Date(date)).getTime(),
                    currentTs = (new Date()).getTime();

                if ($scope.listType == "all") {
                    return true;
                }
                if ($scope.listType == "upcoming") {
                    return ts > currentTs;
                }
                if ($scope.listType == "previous") {
                    return ts <= currentTs;
                }
                if ($scope.listType == "cancelled") {
                    return bookingObj.isCancelled;
                }
            }

            function setFilterTypeFn() {
                if ($routeParams.type) {
                    $scope.listType = $routeParams.type;
                } else {
                    $scope.listType = "all";
                }
            }

            function gotoFilterFn() {
                var currentPath = $location.path();
                $location.path(currentPath).search({ type: $scope.listType });
            }

            function getBookingDataFn() {
                var email = cookieService.readCookie('_uemail'),
                    mobile = cookieService.readCookie('_umobile'),
                    otp = cookieService.readCookie('_uotp'),
                    type, contactInfo;

                if (email) {
                    type = 'email';
                    contactInfo = email;
                }

                if (mobile) {
                    type = 'mobile';
                    contactInfo = mobile;
                }

                if (type && contactInfo && otp) {
                    userVerificationService.getBookingDetails(type, contactInfo, otp);
                    $scope.accountData = accountData;
                } else {
                    $location.path('/user/verify');
                }
            }

            getBookingDataFn();

            $scope.viewType = "booking";
            $scope.urlType = "user";
            $scope.ifPageSliderMatches = ifPageSliderMatchesFn;
            $scope.checkFilter = checkFilterFn;
            $scope.gotoFilter = gotoFilterFn;
            setFilterTypeFn();
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyEditProfile
 * @description
 * # tyEditProfile
 */
angular.module('ngBusApp')
    .directive('tyEditProfile', ['$location', 'accountData',
        function($location, accountData) {
            return {
                templateUrl: "views/tyeditprofile.html",
                scope: {},
                replace: true,
                restrict: 'E',
                controller: ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService',
                    function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService) {

                        function saveProfileFn() {
                            var dobStr = '';
                            if ($scope.editProfile.$valid) {

                                if ($scope.accountData.accountDetails.data.dob.mm &&
                                    $scope.accountData.accountDetails.data.dob.dd &&
                                    $scope.accountData.accountDetails.data.dob.yyyy) {
                                    var d = new Date($scope.accountData.accountDetails.data.dob.mm + "-" + $scope.accountData.accountDetails.data.dob.dd + "-" + $scope.accountData.accountDetails.data.dob.yyyy);

                                    var month = '' + (d.getMonth() + 1),
                                        day = '' + d.getDate(),
                                        year = d.getFullYear();

                                    (month.length < 2) && (month = '0' + month);
                                    (day.length < 2) && (day = '0' + day);

                                    dobStr = [year, month, day].join('-');
                                }
                                var postData = {
                                    name: $scope.accountData.accountDetails.data.name,
                                    gender: $scope.accountData.accountDetails.data.gender,
                                    email: $scope.accountData.accountDetails.data.email,
                                    mobile: $scope.accountData.accountDetails.data.mobile,
                                    dob: dobStr,
                                    phone: '',
                                    address: '',
                                    pincode: '',
                                    state: $scope.accountData.accountDetails.data.state,
                                    city: $scope.accountData.accountDetails.data.city,
                                    preferences: JSON.stringify($scope.accountData.accountDetails.data.interests),
                                    frequency: $scope.accountData.accountDetails.data.frequency
                                }

                                accountData.isProcessing = true;
                                accountService.saveProfile(postData).then(function(response) {
                                        accountData.isProcessing = false;
                                        if (response.data.success) {
                                            accountData.message = 'Profile saved successfully';
                                            accountData.error = false;
                                        } else {
                                            accountData.message = 'Something went wrong. Please try again later';
                                            accountData.error = true;
                                        }
                                    },
                                    function(err) {
                                        accountData.isProcessing = false;

                                        accountData.message = 'Something went wrong. Please try again later';
                                        accountData.error = true;
                                    });
                            } else {
                                var allErrors = [];
                                angular.forEach($scope.editProfile.$error, function(errTypes, key) {
                                    errTypes.forEach(function(value) {
                                        value.$$element && allErrors.push(value.$$element[0])
                                    });
                                });

                                allErrors[0].focus();
                            }
                        }

                        function chooseDobDateFn() {
                            accountData.datePickerDobOpen = true;
                        }

                        function initFn() {
                            $rootScope.navbar.show = false;
                            $rootScope.header.title = "Edit Profile";
                            $rootScope.header.isHeaderSearchType = false;

                            accountData.isProcessing = true;
                            accountService.getAccountDetails(false).then(function(response) {
                                accountData.isProcessing = false;
                            });

                            /*var unregisterWatch = $scope.$watch('editProfile', function() {
                                $scope.editProfile.name.$$element[0].focus();
                                unregisterWatch();
                            });*/

                            $rootScope.metaProperties.data = accountData.accountOptions[0].seoDetails;
                            $rootScope.metaProperties.data.url = $location.$$url;
                        }

                        $scope.accountData = accountData;
                        $scope.saveProfile = saveProfileFn;
                        $scope.chooseDobDate = chooseDobDateFn;

                        initFn();
                    }
                ]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyChangePassword
 * @description
 * # tyChangePassword
 */
angular.module('ngBusApp')
    .directive('tyChangePassword', ['$location', 'accountData',
        function($location, accountData) {
            return {
                templateUrl: "views/tychangepassword.html",
                scope: {},
                replace: true,
                restrict: 'E',
                controller: ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService',
                    function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService) {
                        $scope.accountData = accountData;

                        function submitChangePasswordFn() {
                            if ($scope.changePwdForm.$valid) {

                                if ($scope.newPassword !== $scope.confirmPassword) {
                                    alert('Confirm password does not match new password');
                                } else {
                                    var postData = {
                                        oldpassword: $scope.oldPassword,
                                        newpassword: $scope.newPassword,
                                        newpassword2: $scope.confirmPassword
                                    };

                                    accountData.isProcessing = true;
                                    accountService.changePassword(postData).then(function(response) {
                                            if (response.data.success) {
                                                // $location.path('/account');
                                                accountData.message = 'Password changed successfully';
                                                accountData.error = false;

                                            } else {
                                                accountData.message = response.data.error.message;
                                                accountData.error = true;
                                            }
                                            accountData.isProcessing = false;
                                        },
                                        function(err) {
                                            accountData.message = 'Something went wrong. Please try again later';
                                            accountData.error = true;
                                            accountData.isProcessing = false;
                                        });
                                }
                            } else {
                                if ($scope.changePwdForm.$error.minlength && $scope.changePwdForm.$error.minlength.length) {
                                    accountData.message = 'Password should be minimum 8 charecters';
                                    accountData.error = true;
                                }
                                var allErrors = [];
                                angular.forEach($scope.changePwdForm.$error, function(errTypes, key) {
                                    errTypes.forEach(function(value) {
                                        value.$$element && allErrors.push(value.$$element[0])
                                    });
                                });

                                allErrors[0] && allErrors[0].focus();
                            }
                        }

                        function initFn() {
                            $scope.accountData = accountData;
                            /*var unregisterWatch = $scope.$watch('changePwdForm', function() {
                                $scope.changePwdForm.oldPwd.$$element[0].focus();
                                unregisterWatch();
                            });*/
                            $rootScope.metaProperties.data = accountData.accountOptions[4].seoDetails;
                            $rootScope.metaProperties.data.url = $location.$$url;
                        }
                        
                        $scope.submitChangePassword = submitChangePasswordFn;
                        initFn();
                    }
                ]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyPrivilegeCard
 * @description
 * # tyPrivilegeCard
 */
angular.module('ngBusApp')
    .directive('tyPrivilegeCard', ['$location', 'accountData',
        function($location, accountData) {
            return {
                templateUrl: "views/typrivilegecard.html",
                scope: {},
                replace: true,
                restrict: 'E',
                controller: ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService',
                    function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService) {

                        function changeTierLabelColorFn(color) {
                            if (color) {
                                return 'ty-label-' + color.toLowerCase();
                            } else {
                                return '';
                            }
                        }

                        function initFn() {
                            accountService.getLoyaltyDetails(false);
                            $scope.accountData = accountData;
                            $rootScope.metaProperties.data = accountData.accountOptions[3].seoDetails;
                            $rootScope.metaProperties.data.url = $location.$$url;
                        }


                        $scope.changeTierLabelColor = changeTierLabelColorFn;
                        initFn();
                    }
                ]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyViewBookings
 * @description
 * # tyViewBookings
 */
angular.module('ngBusApp')
    .directive('tyViewBookings', ['$location', 'accountData',
        function($location, accountData) {
            return {
                templateUrl: "views/tyviewbookings.html",
                scope: {
                    'urlType':'='
                },
                replace: true,
                restrict: 'E',
                controller: ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService',
                    function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService) {

                        function checkFilterFn(bookingObj) {

                            var date = bookingObj.vertical == 'hotel' ? bookingObj.checkInDate : bookingObj.doj,
                                ts = (new Date(date)).getTime(),
                                currentTs = (new Date()).getTime();

                            if ($scope.listType == "all") {
                                return true;
                            }
                            if ($scope.listType == "upcoming") {
                                return ts > currentTs;
                            }
                            if ($scope.listType == "previous") {
                                return ts <= currentTs;
                            }
                            if ($scope.listType == "cancelled") {
                                return bookingObj.isCancelled;
                            }
                        }

                        function setFilterTypeFn() {
                            if ($routeParams.type) {
                                $scope.listType = $routeParams.type;
                            } else {
                                $scope.listType = "all";
                            }
                        }

                        function gotoFilterFn() {
                            var currentPath = $location.path();
                            $location.path(currentPath).search({ type: $scope.listType });
                        }

                        function setTabFn(tabId) {
                            $scope.selectedTab = tabId;
                        }

                        function initFn() {
                            $scope.selectedTab = 1;
                            setFilterTypeFn();

                            $scope.viewType = "booking";

                            // $scope.urlType = "account";
                            $rootScope.metaProperties.data = accountData.accountOptions[1] == 'bookings' ? accountData.accountOptions[1].seoDetails : accountData.accountOptions[0].seoDetails;
                            $rootScope.metaProperties.data.url = $location.$$url;
                        }

                        if($scope.urlType == 'account'){
                            accountService.getBookingDetails(true);
                        }
                        $scope.accountData = accountData;
                        $scope.checkFilter = checkFilterFn;
                        $scope.gotoFilter = gotoFilterFn;
                        $scope.setTab = setTabFn;

                        initFn();
                    }
                ]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc directive
 * @name ngBusApp.directive:tyRefundStatus
 * @description
 * # tyRefundStatus
 */
angular.module('ngBusApp')
    .directive('tyRefundStatus', ['$location', 'accountData',
        function($location, accountData) {
            return {
                templateUrl: "views/tyrefundstatus.html",
                scope: {
                    'urlType': '='
                },
                replace: true,
                restrict: 'E',
                controller: ['CONSTANTS', '$routeParams', '$location', '$rootScope', '$scope', 'accountData', 'accountService',
                    function(CONSTANTS, $routeParams, $location, $rootScope, $scope, accountData, accountService) {

                        function checkFilterFn(bookingObj) {

                            var date = bookingObj.vertical == 'hotel' ? bookingObj.checkInDate : bookingObj.doj,
                                ts = (new Date(date)).getTime(),
                                currentTs = (new Date()).getTime();

                            if ($scope.listType == "all") {
                                return true;
                            }
                            if ($scope.listType == "upcoming") {
                                return ts > currentTs;
                            }
                            if ($scope.listType == "previous") {
                                return ts <= currentTs;
                            }
                            if ($scope.listType == "cancelled") {
                                return bookingObj.isCancelled;
                            }
                        }

                        function setFilterTypeFn() {
                            $scope.listType = "cancelled";
                        }

                        function gotoFilterFn() {
                            var currentPath = $location.path();
                            $location.path(currentPath).search({ type: $scope.listType });
                        }

                        function setTabFn(tabId) {
                            $scope.selectedTab = tabId;
                        }

                        function initFn() {
                            // $scope.urlType = "account";
                            $scope.viewType = "refund";
                            $scope.selectedTab = 1;
                            setFilterTypeFn();

                            accountService.getBookingDetails(true);
                            $scope.accountData = accountData;

                            console.log(accountData.accountOptions);
                            $rootScope.metaProperties.data = accountData.accountOptions[3] ? accountData.accountOptions[3].seoDetails : accountData.accountOptions[1].seoDetails;
                            $rootScope.metaProperties.data.url = $location.$$url;
                        }

                        $scope.checkFilter = checkFilterFn;
                        $scope.gotoFilter = gotoFilterFn;
                        $scope.setTab = setTabFn;

                        initFn();
                    }
                ]
            };
        }
    ]);

'use strict';

/**
 * @ngdoc service
 * @name ngBusApp.printTicketService
 * @description
 * # printTicketService
 * Factory in the ngBusApp.
 */
angular.module('ngBusApp')
    .factory('printTicketService', ['CONSTANTS', function(CONSTANTS) {
        var printObject = {
            url: ''
        };
        // Public API here
        return {
            printBusTicket: function(pnr, ticketNo) {
                printObject.url = CONSTANTS.API_URL + "/ty2/ticket/getBusReservationTicket/" + pnr + "/" + ticketNo;
                window.open(printObject.url);
            },
            printPackageTicket: function(bookingId) {
                printObject.url = CONSTANTS.API_URL + "/ty2/package/getPackageReservationTicket/" + bookingId;
                window.open(printObject.url);
            },
            printHotelTicket: function(bookingId) {
                printObject.url = CONSTANTS.API_URL + "/hotel/printTicket/" + bookingId;
                window.open(printObject.url);
            }
        };
    }]);

'use strict';

/**
 * @ngdoc function
 * @name ngBusApp.controller:LoginMethodCtrl
 * @description
 * # LoginMethodCtrl
 * Controller of the ngBusApp
 */
angular.module('ngBusApp')
    .controller('LoginMethodCtrl', ['$scope', '$rootScope', '$routeParams', '$location', 'cookieService',
        function($scope, $rootScope, $routeParams, $location, cookieService) {
            function getBookingDataFn() {
                var email = cookieService.readCookie('_uemail'),
                    mobile = cookieService.readCookie('_umobile'),
                    otp = cookieService.readCookie('_uotp'),
                    type, contactInfo;

                if (email) {
                    type = 'email';
                    contactInfo = email;
                }

                if (mobile) {
                    type = 'mobile';
                    contactInfo = mobile;
                }

                if (type && contactInfo && otp) {
                    $location.path('/user/bookings');
                }
            }

            getBookingDataFn();

            $rootScope.footer.show = false;
            $rootScope.metaProperties.data.title = 'My Bookings: Login, OTP, PNR No or Booking ID | Travelyaari';
            $rootScope.metaProperties.data.url = $location.$$url;
        }
    ]);

angular.module('ngBusApp').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('views/authenticateuser.html',
    "<div class=\"_uv\"> <ty-processing loading=\"isProcessing\" class=\"ty-loader-sm ty-account-loader\"></ty-processing> <div class=\"container no-margin\"> <div class=\"col-xs-12\"> <div class=\"container-card\"> <div>{{userVerificationData.userData.remark}}</div> <form class=\"ty-form user-verify-form\" name=\"otpVerify\" ng-submit=\"verifyOtp()\" novalidate> <div class=\"ty-info-label\"> <label>OTP (valid till next 10 minutes only)</label> </div> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : otpVerify.$submitted && otpVerify.otp.$invalid}\"> <input class=\"ty-form-control\" name=\"otp\" type=\"tel\" ng-required=\"true\" ng-model=\"otp\"> <label>Enter OTP for validation</label> </div> <div class=\"ty-button-container\"> <button class=\"ty-button ty-button-orange\" ng-disabled=\"\" type=\"submit\"> VERIFY </button> </div> </form> </div> </div> </div> </div>"
  );


  $templateCache.put('views/bookingdetails.html',
    "<div class=\"_bd container-fluid no-margin\"> <div class=\"col-md-8\"> <ty-bus-booking-details ng-if=\"accountData.selectedBooking.card.vertical=='bus'\" class=\"col-xs-12 container-card\"></ty-bus-booking-details> <ty-tour-booking-details ng-if=\"accountData.selectedBooking.card.vertical=='tour' || accountData.selectedBooking.card.vertical=='activity'\" class=\"col-xs-12 container-card\"></ty-tour-booking-details> <ty-hotel-booking-details ng-if=\"accountData.selectedBooking.card.vertical=='hotel'\" class=\"col-xs-12 container-card\"></ty-hotel-booking-details> </div> </div>"
  );


  $templateCache.put('views/changepassword.html',
    "<div class=\"_ep\"> <ty-change-password style=\"margin-left: 5px\"></ty-change-password> </div>"
  );


  $templateCache.put('views/details.html',
    "<div class=\"_acc\"> <ty-processing class=\"ty-loader-sm ty-account-loader\" loading=\"accountData.isProcessing\"></ty-processing> <div class=\"container-fluid loyalty-container\" ng-if=\"urlType !== 'user'\"> <div class=\"container\"> <div class=\"col-xs-4\"> <div class=\"profile-basics\"> <div class=\"profile-picture-container\"> <ng-lazy-load-img imgsrc=\"accountData.accountDetails.data.image\" default-image=\"'/images/avatar_profile.png'\" class=\"profile-picture\"></ng-lazy-load-img> </div> </div> </div> <div class=\"col-xs-6\"> <div class=\"loyalty-msg ng-hide\">You saved <i class=\"icon-inr\"></i>{{::accountData.loyaltyDetails.data.discount}} using travelyaari bookings</div> </div> <div class=\"col-xs-2\"> <div class=\"loyalty-info\"> <div class=\"col-xs-6 loyalty-points\"> <div class=\"loyalty-label\"><span>{{::accountData.loyaltyDetails.data.points}}</span> <br>Points</div> </div> <div class=\"col-xs-6\"> <div class=\"loyalty-label\"><span ng-class=\"changeTierLabelColor(accountData.loyaltyDetails.data.tier)\">{{::accountData.loyaltyDetails.data.tier}}</span> <br>Tier</div> </div> </div> </div> </div> </div> <div class=\"container tab-container\"> <div class=\"row\"> <div class=\"col-xs-4 account-navigator\"> <div class=\"row account-options\" ng-repeat=\"option in accountData.accountOptions\" ng-class=\"{'active': option.module == currentModule}\"> <a href=\"{{option.url}}\" class=\"ty-link ty-link-inherit-color\" target=\"{{option.target}}\"> <div class=\"col-xs-2\"> <i class=\"account-option-icon {{option.icon}}\"></i> </div> <div class=\"account-option-title col-xs-10\" ng-bind-html=\"option.title\"></div> </a> </div> </div> <div class=\"col-xs-8\"> <div class=\"back-btn-container\"> <a href=\"/{{::urlType}}/{{::currentModule}}\" class=\"ty-link ty-btn ty-btn-info\" ng-if=\"currentModule == 'bookings'\">&lt; Back to your bookings</a> <a href=\"/{{::urlType}}/{{::currentModule}}\" class=\"ty-link ty-btn ty-btn-info\" ng-if=\"currentModule == 'refund'\">&lt; Back to cancelled trips</a> </div> <div ng-include=\"'views/bookingdetails.html'\"></div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/editprofile.html',
    "<div class=\"_ep\"> <ty-edit-profile></ty-edit-profile> </div>"
  );


  $templateCache.put('views/loginoptions.html',
    "<div class=\"_lm\"> <div class=\"container\"> <div class=\"col-sm-12\"> <div class=\"login-options\"> <div class=\"msg\">Select one of the following to proceed further:</div> <div class=\"row\"> <div class=\"col-sm-6 option\"> <a href=\"/login\" class=\"ty-link\" target=\"_self\"> <div class=\"name\">LOGIN</div> <div class=\"desc\">To edit / view all your account details including booking.</div> </a> </div> </div> <div class=\"row\"> <div class=\"col-sm-6 option\"> <a href=\"/user/booking\" class=\"ty-link\"> <div class=\"name\">OTP</div> <div class=\"desc\">To edit / view specific booking as per email / mobile no.</div> </a> </div> </div> <div class=\"row\"> <div class=\"col-sm-6 option\"> <a href=\"/print/bus\" class=\"ty-link\" target=\"_self\"> <div class=\"name\">PNR NO / BOOKING ID</div> <div class=\"desc\">To view / print / email / sms specific booking.</div> </a> </div> </div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/myaccount.html',
    "<div class=\"_acc\"> <ty-processing class=\"ty-loader-sm ty-account-loader\" loading=\"accountData.isProcessing\"></ty-processing> <div class=\"loyalty-container\"> <div class=\"container\"> <div class=\"col-xs-4\"> <div class=\"profile-basics\"> <div class=\"profile-picture-container\"> <ng-lazy-load-img imgsrc=\"'/images/avatar_profile.png'\" default-image=\"'/images/avatar_profile.png'\" class=\"profile-picture\"></ng-lazy-load-img> </div> <div class=\"profile-name\" ng-bind=\"accountData.loyaltyDetails.data.name\"></div> </div> </div> <div class=\"col-xs-4\"> <div class=\"loyalty-msg ng-hide\">You saved <i class=\"icon-inr\"></i>{{::accountData.loyaltyDetails.data.discount}} using travelyaari bookings</div> </div> <div class=\"col-xs-4\"> <div class=\"loyalty-info\"> <div class=\"col-xs-6 loyalty-points\"> <div class=\"loyalty-label\"><span>{{::accountData.loyaltyDetails.data.points}}</span><br>Points</div> </div> <div class=\"col-xs-6\"> <div class=\"loyalty-label\"><span ng-class=\"changeTierLabelColor(accountData.loyaltyDetails.data.tier)\">{{::accountData.loyaltyDetails.data.tier}}</span><br>Tier</div> </div> </div> </div> </div> </div> <div class=\"container tab-container\"> <div class=\"row\"> <div class=\"col-xs-3 account-navigator\"> <div class=\"row account-options\" ng-repeat=\"option in accountData.accountOptions\" ng-class=\"{'active': option.module == currentModule}\"> <a href=\"{{option.url}}\" class=\"ty-link ty-link-inherit-color\" target=\"{{option.target}}\"> <div class=\"col-xs-2\"> <i class=\"account-option-icon {{option.icon}}\"></i> </div> <div class=\"account-option-title col-xs-10\" ng-bind-html=\"option.title\"></div> </a> </div> </div> <div class=\"col-xs-9\"> <div> <div ng-repeat=\"option in accountData.accountOptions\" ng-include=\"option.view\" ng-if=\"option.module == currentModule\"></div> </div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/privilegecard.html',
    "<div class=\"_lp\"> <ty-privilege-card></ty-privilege-card> </div>"
  );


  $templateCache.put('views/refundstatus.html',
    "<div class=\"_vb\"> <ty-refund-status url-type=\"urlType\"></ty-refund-status> </div>"
  );


  $templateCache.put('views/tybookingactivityresults.html',
    "<div class=\"container-fluid\"> <div class=\"\"> <ty-booking-card class=\"booking-card col-md-6\" booking-data=\"booking\" ng-repeat=\"booking in accountData.bookingList.data.activity\" ng-if=\"checkFilter(booking)\" view-type=\"viewType\" url-type=\"urlType\"></ty-booking-card> <div class=\"no-results col-md-6\" ng-if=\"viewType!=='refund'\">No booked activities</div> <div class=\"no-results col-md-6\" ng-if=\"viewType==='refund'\">You have not requested any cancellation</div> </div> </div>"
  );


  $templateCache.put('views/tybookingallresults.html',
    "<div class=\"container-fluid\"> <div class=\"\"> <ty-booking-card class=\"booking-card col-md-6\" booking-data=\"booking\" ng-repeat=\"booking in accountData.bookingList.data.all\" ng-if=\"checkFilter(booking)\" view-type=\"viewType\" url-type=\"urlType\"></ty-booking-card> <div class=\"no-results col-md-6\" ng-if=\"accountData.isProcessing\">Loading...</div> <div class=\"no-results col-md-6\" ng-if=\"!accountData.isProcessing && viewType!=='refund'\">No bookings found</div> <div class=\"no-results col-md-6\" ng-if=\"!accountData.isProcessing && viewType==='refund'\">You have not requested any cancellation</div> </div> </div>"
  );


  $templateCache.put('views/tybookingbusresults.html',
    "<div class=\"container-fluid\"> <div class=\"\"> <ty-booking-card class=\"booking-card col-md-6\" booking-data=\"booking\" ng-repeat=\"booking in accountData.bookingList.data.bus\" ng-if=\"checkFilter(booking)\" view-type=\"viewType\" url-type=\"urlType\"></ty-booking-card> <div class=\"no-results col-md-6\" ng-if=\"viewType!=='refund'\">No booked trips</div> <div class=\"no-results col-md-6\" ng-if=\"viewType==='refund'\">You have not requested any cancellation</div> </div> </div>"
  );


  $templateCache.put('views/tybookingcard.html',
    "<div> <a class=\"ty-link ty-link-inherit-color\" ng-href=\"/{{::urlType}}/{{::viewType}}/details/{{::bookingData.token}}\" ng-click=\"isClickable(bookingData.isCancelled, $event)\"> <div class=\"booking-card-container\" ng-if=\"bookingData.vertical=='bus'\" ng-class=\"{'disabled':bookingData.isCancelled}\"> <div class=\"booking-each-card\"> <div class=\"date-section\">{{::bookingData.doj | date: \"EEE, dd MMM yyyy\"}}</div> <div class=\"info-section\"> <i class=\"icon-directions_bus booking-card-icon\"></i> <div class=\"ty-time-location-info\"> <div class=\"ty-time-dashed-line\"></div> <div class=\"ty-booking-frominfo\"> <div class=\"ty-booking-info-city\"> {{::bookingData.frm}} </div> <div class=\"ty-booking-info-time\"> {{::bookingData.pickup}} </div> </div> <div class=\"ty-booking-toinfo\"> <div class=\"ty-booking-info-city\"> {{::bookingData.to}} </div> <div class=\"ty-booking-info-time\"> {{::bookingData.drop}} </div> </div> </div> </div> </div> </div> </a> <a class=\"ty-link ty-link-inherit-color\" ng-href=\"/{{::urlType}}/{{::viewType}}/details/{{::bookingData.token}}\" ng-click=\"isClickable(bookingData.isCancelled, $event)\"> <div class=\"booking-card-container\" ng-if=\"bookingData.vertical=='hotel'\" ng-class=\"{'disabled':bookingData.isCancelled}\"> <div class=\"booking-each-card\"> <div class=\"date-section\">{{::bookingData.checkInDate | date: \"EEE, dd MMM yyyy\"}}</div> <div class=\"info-section\"> <i class=\"icon-local_hotel booking-card-icon\"></i> <div class=\"ty-booking-info-heading\"> {{::bookingData.hotelName}} </div> <div class=\"ty-booking-info-details row\"> <div class=\"col-xs-6\"> Check-in <br>{{::bookingData.checkInDate | date: \"dd MMM\"}} </div> <div class=\"col-xs-6\"> Check-out <br>{{::bookingData.checkOutDate | date: \"dd MMM\"}} </div> </div> </div> </div> </div> </a> <a class=\"ty-link ty-link-inherit-color\" ng-href=\"/{{::urlType}}/{{::viewType}}/details/{{::bookingData.token}}\" ng-click=\"isClickable(bookingData.isCancelled, $event)\"> <div class=\"booking-card-container\" ng-if=\"bookingData.vertical=='tour'\" ng-class=\"{'disabled':bookingData.isCancelled}\"> <div class=\"booking-each-card\"> <div class=\"date-section\">{{::bookingData.doj | date: \"EEE, dd MMM yyyy\"}}</div> <div class=\"info-section\"> <i class=\"icon-tour booking-card-icon\"></i> <div class=\"ty-booking-info-heading\"> {{::bookingData.packageName}} </div> <div class=\"ty-booking-info-details row\"> <div class=\"col-xs-6\"> No. of Days <br>{{::bookingData.numDays}} </div> <div class=\"col-xs-6\"> No. of People <br>{{::bookingData.paxCount}} </div> </div> </div> </div> </div> </a> <a class=\"ty-link ty-link-inherit-color\" ng-href=\"/{{::urlType}}/{{::viewType}}/details/{{::bookingData.token}}\" ng-click=\"isClickable(bookingData.isCancelled, $event)\"> <div class=\"booking-card-container\" ng-if=\"bookingData.vertical=='activity'\" ng-class=\"{'disabled':bookingData.isCancelled}\"> <div class=\"booking-each-card\"> <div class=\"date-section\">{{::bookingData.doj | date: \"EEE, dd MMM yyyy\"}}</div> <div class=\"info-section\"> <i class=\"icon-directions_bike booking-card-icon\"></i> <div class=\"ty-booking-info-heading\"> {{::bookingData.packageName}} </div> <div class=\"ty-booking-info-details row\"> <div class=\"col-xs-6\"> No. of Days <br>{{::bookingData.numDays}} </div> <div class=\"col-xs-6\"> No. of People <br>{{::bookingData.paxCount}} </div> </div> </div> </div> </div> </a> </div>"
  );


  $templateCache.put('views/tybookinghotelresults.html',
    "<div class=\"container-fluid\"> <div class=\"\"> <ty-booking-card class=\"booking-card col-md-6\" booking-data=\"booking\" ng-repeat=\"booking in accountData.bookingList.data.hotel\" ng-if=\"checkFilter(booking)\" view-type=\"viewType\" url-type=\"urlType\"></ty-booking-card> <div class=\"no-results col-md-6\" ng-if=\"viewType!=='refund'\">No booked rooms</div> <div class=\"no-results col-md-6\" ng-if=\"viewType==='refund'\">You have not requested any cancellation</div> </div> </div>"
  );


  $templateCache.put('views/tybookingtourresults.html',
    "<div class=\"container-fluid\"> <div class=\"\"> <ty-booking-card class=\"booking-card col-md-6\" booking-data=\"booking\" ng-repeat=\"booking in accountData.bookingList.data.tour\" ng-if=\"checkFilter(booking)\" view-type=\"viewType\" url-type=\"urlType\"></ty-booking-card> <div class=\"no-results col-md-6\" ng-if=\"viewType!=='refund'\">No booked tours</div> <div class=\"no-results col-md-6\" ng-if=\"viewType==='refund'\">You have not requested any cancellation</div> </div> </div>"
  );


  $templateCache.put('views/tybusbookingdetails.html',
    "<div> <div class=\"ty-msg\" ng-class=\"{'ty-error': error,'ty-success':!error}\" ng-show=\"message\" ng-bind=\"message\"></div> <div ng-show=\"!reasonPage\"> <ty-booking-card view-type=\"viewType\" url-type=\"urlType\" booking-data=\"accountData.selectedBooking.card\"></ty-booking-card> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Ticket Number</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.SubAgentTicketNo}}</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">PNR Number</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.PNRNo}}</div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Bus Type</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.BusTypeName}}</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Operator Name</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.CompanyName}}</div> </div> </div> <div ng-if=\"viewType !== 'refund'\"> <form name=\"formBusDetails\" onsubmit=\"return false\"> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-passenger-details\"> <div class=\"passenger-details-heading booking-detail-section-heading\"> <div class=\"detail-data\">Passenger</div> <div class=\"detail-data\">Age</div> <div class=\"detail-data\">Seat</div> <div class=\"detail-data\">Fare</div> </div> <div class=\"passenger-details-body booking-detail-section-data\" ng-repeat=\"passenger in accountData.selectedBooking.data.Passengers track by $index\"> <div class=\"detail-data\"> <label class=\"ty-checkbox ty-checkbox-blue\" ng-click=\"myClick(passenger.SeatNo)\" ng-if=\"isCancelInitiated\"> <input type=\"checkbox\" name=\"selectedCard[]\" ng-value=\"passenger.SeatNo\" ng-model=\"accountData.busSeatsToCancel[passenger.SeatNo]\"> <i class=\"icon-tick\"></i> </label> {{::passenger.Name}} </div> <div class=\"detail-data\">{{::passenger.Age}}</div> <div class=\"detail-data\">{{::passenger.SeatNo}}</div> <div class=\"detail-data\">{{::passenger.Fare}}</div> </div> </div> </div> </form> <div class=\"row booking-detail-section\" ng-if=\"isCancelInitiated\"> <div class=\"col-xs-8\">Cancellation Charges</div> <div class=\"col-xs-8 booking-passenger-details\"> <div class=\"passenger-details-heading booking-detail-section-heading\"> <div class=\"detail-data\">Cancellation Time</div> <div class=\"detail-data\">Charges</div> </div> <div class=\"passenger-details-body booking-detail-section-data\" ng-repeat=\"canc in accountData.selectedBooking.data.Cancellations track by $index\"> <div class=\"detail-data\" ng-if=\"$index!==accountData.selectedBooking.data.Cancellations.length-1\">From {{::canc.Mins / 60 | number:0}} to {{::accountData.selectedBooking.data.Cancellations[$index + 1].Mins / 60 | number:0}} hrs</div> <div class=\"detail-data\" ng-if=\"$index===accountData.selectedBooking.data.Cancellations.length-1\">Before {{::canc.Mins / 60 | number:0}} hrs</div> <div ng-if=\"canc.Amt\" class=\"detail-data\">Rs. {{::canc.Amt}}</div> <div ng-if=\"!canc.Amt\" class=\"detail-data\">{{::canc.Pct}} %</div> </div> </div> </div> <div class=\"row booking-detail-section\" ng-if=\"!isCancelInitiated\"> <div class=\"col-xs-12 booking-detail-section-heading\"> Email: {{::accountData.selectedBooking.data.ContactInfo.Email}} </div> </div> <div class=\"row booking-detail-section\" ng-if=\"!isCancelInitiated\"> <div class=\"col-xs-12 booking-detail-section-heading\"> Mobile: +91 {{::accountData.selectedBooking.data.ContactInfo.Mobile}} </div> </div> </div> <div ng-if=\"viewType === 'refund'\"> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Cancellation Date</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.CancelDate | date: \"dd MMM yyyy\"}}</div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Refund Amount</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\"><i class=\"icon-inr\"></i>{{::accountData.selectedBooking.data.RefundAmount}}</div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Refund Status</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\" ng-if=\"accountData.selectedBooking.data.IsRefundInitiated\">Initiated</div> <div class=\"booking-detail-section-data\" ng-if=\"!accountData.selectedBooking.data.IsRefundInitiated\">Pending</div> </div> </div> </div> </div> <div class=\"row booking-actions\" ng-show=\"!reasonPage\">  <div class=\"col-xs-12\"> <div ng-if=\"!isCancelInitiated\"> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"printTicket(accountData.selectedBooking.data.SubAgentTicketNo, accountData.selectedBooking.data.PNRNo)\">Print</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"emailTicket(accountData.selectedBooking.data.SubAgentTicketNo, accountData.selectedBooking.data.PNRNo, accountData.selectedBooking.data.ContactInfo.Email)\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">Email</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"smsTicket(accountData.selectedBooking.data.SubAgentTicketNo, accountData.selectedBooking.data.PNRNo, accountData.selectedBooking.data.ContactInfo.Mobile)\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">SMS</a>  <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"confirmCancelTicket()\" ng-if=\"accountData.selectedBooking.card.isCancellable && !accountData.selectedBooking.card.isCancelled\">Cancel</a> </div> <div ng-if=\"isCancelInitiated\"> <button class=\"ty-button ty-button-orange\" ng-click=\"proccedToCancelTicket()\" ng-disabled=\"accountData.isProcessing\"> CANCEL SELECTED BOOKING </button> </div> </div> </div> <div ng-show=\"reasonPage\"> <div class=\"cancel-confirmation\"> Choose reason for Cancellation <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Change of plan/dates\" value=\"Change of plan/dates\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\" ng-checked=\"true\"><i></i> </label> <span>Change of plan / dates</span> </label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Not travelling at all\" value=\"Not travelling at all\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i> </label> <span>Not travelling at all</span></label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Book other travel options\" value=\"Book other travel options\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i> </label> <span>Booked other travel options</span></label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Others\" value=\"Others\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i></label> <span>Others</span></label><i></i> </div> </div> <div class=\"row ty-input-group-inline ticket-submit-btn\"> <button class=\"ty-button ty-button-orange\" ng-click=\"cancelTicket(accountData.selectedBooking.data.SubAgentTicketNo, accountData.selectedBooking.data.PNRNo, accountData.selectedBooking.data.ContactInfo.Email)\" ng-disabled=\"disableFinalBtn\">CONFIRM CANCELLATION</button> </div> </div> </div>"
  );


  $templateCache.put('views/tybusheader.html',
    "<div class=\"ty-site-header\" ng-cloak ng-show=\"!navbar.show\" ng-class=\"{'ty-site-header-fixed':isHeaderFixed}\"> <i class=\"icon-arrow_back ty-menu\" ng-click=\"goBack()\"></i> <div class=\"ty-header-title\" ng-class=\"{'ty-header-title-blue':isHeaderClickable}\" ng-click=\"isHeaderClickable && openModal(['header-event'])\"> <img src=\"/images/t-transparent.png\" ng-show=\"header.isLogoVisible\"> <span ng-bind=\"header.title\"></span> </div> <i class=\"icon-map-marker ty-right-menu\" ng-show=\"header.isHeaderSearchType\"></i> <i class=\"icon-more2 ty-right-menu\" ng-click=\"openModal(['menuRightShow'])\" ng-show=\"header.isMenuRightVisible\"></i> </div>"
  );


  $templateCache.put('views/tychangepassword.html',
    "<div> <div class=\"row\"> <div class=\"section-heading col-xs-12\">Change Password</div> </div> <div class=\"ty-msg\" ng-class=\"{'ty-error': accountData.error,'ty-success':!accountData.error}\" ng-show=\"accountData.message\" ng-bind=\"accountData.message\"></div> <div class=\"row\"> <div class=\"col-xs-7\"> <form class=\"ty-form\" name=\"changePwdForm\" ng-submit=\"submitChangePassword()\" novalidate autocomplete=\"off\">  <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : changePwdForm.$submitted && changePwdForm.oldPwd.$invalid}\"> <input class=\"ty-form-control\" name=\"oldPwd\" type=\"password\" ng-required=\"true\" ng-model=\"oldPassword\" minlength=\"8\"> <label>Current password</label> </div> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : changePwdForm.$submitted && changePwdForm.newPwd.$invalid}\"> <input class=\"ty-form-control\" name=\"newPwd\" type=\"password\" ng-required=\"true\" ng-model=\"newPassword\" minlength=\"8\"> <label>New password</label> </div> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : changePwdForm.$submitted && changePwdForm.confirmPwd.$invalid}\"> <input class=\"ty-form-control\" name=\"confirmPwd\" type=\"password\" ng-required=\"true\" ng-model=\"confirmPassword\" minlength=\"8\"> <label>Confirm password</label> </div> <div class=\"ty-form-action-group\"> <button class=\"ty-button ty-button-orange\" ng-disabled=\"accountData.isProcessing\" type=\"submit\"> UPDATE PASSWORD </button> </div> </form> </div> </div> </div>"
  );


  $templateCache.put('views/tyeditprofile.html',
    "<div class=\"container-fluid\"> <div class=\"row\"> <div class=\"col-md-12 section-heading\">Personal Info</div> </div> <div class=\"ty-msg\" ng-class=\"{'ty-error': accountData.error,'ty-success':!accountData.error}\" ng-show=\"accountData.message\" ng-bind=\"accountData.message\"></div> <form class=\"ty-form\" name=\"editProfile\" novalidate> <div class=\"row\"> <div class=\"col-md-6\"> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : editProfile.$submitted && editProfile.name.$invalid}\"> <input class=\"ty-form-control\" name=\"name\" type=\"text\" ng-model=\"accountData.accountDetails.data.name\" ng-required=\"true\" ng-pattern=\"/^[a-z][a-z\\s\\.]+[a-z]$/i\" ty-validate-on-keypress=\"name\" maxlength=\"50\"> <label for=\"name\">Name *</label> </div> <div class=\"profile-mobile\"> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : editProfile.$submitted && editProfile.mobile.$invalid}\"> <select class=\"ty-form-control\" name=\"mobileCountry\" ng-model=\"mobileCountry\" ng-init=\"mobileCountry='10'\"> <option value=\"10\">+91</option> <option value=\"15\">Intl.</option> </select> <span class=\"icon-arrow_drop_down dropdown-position\" style=\"top:3px;left:30px\"></span> <input class=\"ty-form-control\" name=\"mobile\" type=\"text\" maxlength=\"{{mobileCountry}}\" ng-model=\"accountData.accountDetails.data.mobile\" ng-required=\"true\" ty-validate-on-keypress=\"number\" minlength=\"10\"> <label for=\"mobile\">Mobile Number *</label> </div> </div> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : editProfile.$submitted && editProfile.email.$invalid}\"> <input class=\"ty-form-control\" type=\"email\" name=\"email\" ng-model=\"accountData.accountDetails.data.email\" ng-required=\"true\" maxlength=\"50\" disabled> <label>Email *</label> </div> <div class=\"profile-input row\"> <div class=\"profile-lbl col-xs-3\">Gender</div> <div class=\"col-xs-9 profile-gender\"> <label> <input type=\"radio\" name=\"gender\" value=\"male\" ng-model=\"accountData.accountDetails.data.gender\"> <div class=\"profile-gender-icon\"><i class=\"icon-male\"></i></div><span class=\"gender-text\">Male</span> </label> <label> <input type=\"radio\" name=\"gender\" value=\"female\" ng-model=\"accountData.accountDetails.data.gender\"> <div class=\"profile-gender-icon\"><i class=\"icon-female\"></i></div><span class=\"gender-text\">Female</span> </label> </div>  </div> <div class=\"profile-input profile-dob row\"> <div class=\"profile-lbl col-xs-4\">Date of Birth</div> <div class=\"ty-input-group ty-input-group-borderless\" style=\"width: 66%\"> <div class=\"row\"> <div class=\"col-xs-3\"> <input class=\"ty-form-control ty-date\" ng-model=\"accountData.accountDetails.data.dob.dd\" ty-date-input=\"dd\" type=\"tel\" ng-required maxlength=\"2\" placeholder=\"DD\" tabindex=\"1\" value=\"\">/ </div> <div class=\"col-xs-3\"> <input class=\"ty-form-control ty-date\" ng-model=\"accountData.accountDetails.data.dob.mm\" ty-date-input=\"mm\" type=\"tel\" ng-required maxlength=\"2\" placeholder=\"MM\" tabindex=\"2\" value=\"\">/ </div> <div class=\"col-xs-6\"> <input class=\"ty-form-control\" ng-model=\"accountData.accountDetails.data.dob.yyyy\" ty-date-input=\"yyyy\" type=\"tel\" ng-required maxlength=\"4\" placeholder=\"YYYY\" tabindex=\"3\" value=\"\"> </div> </div> </div> </div>  <div class=\"profile-input profile-address\"> <div class=\"ty-input-group ty-input-group-borderless\"> <input class=\"ty-form-control\" type=\"text\" ng-model=\"accountData.accountDetails.data.city\" ty-validate-on-keypress=\"name\" maxlength=\"25\"> <label>City</label> </div> </div> <div class=\"profile-input profile-address\"> <div class=\"ty-input-group ty-input-group-borderless\"> <input class=\"ty-form-control\" type=\"text\" ng-model=\"accountData.accountDetails.data.state\" ty-validate-on-keypress=\"name\" maxlength=\"25\"> <label>State</label> </div> </div> </div> <div class=\"col-md-1\">&nbsp;</div> <div class=\"col-md-5\"> <div class=\"profile-preferences\"> <div class=\"profile-section-heading\">Interests/ Preferences</div> <label ng-repeat=\"interest in accountData.accountDetails.data.interests track by $index\"> <input type=\"checkbox\" name=\"preference\" ng-model=\"interest.status\" value=\"true\" ng-checked=\"interest.status\"> <div class=\"pref-item\"><i class=\"{{interest.icon}} pref-icon\"></i> <div class=\"pref-name\">{{::interest.name}}</div> <div class=\"pref-item-checked-wrapper\"> <div class=\"pref-item-checked\"><i class=\"icon-tick\"></i> </div> </div> </div> </label> </div> <div class=\"profile-travel-frequency\"> <div class=\"profile-section-heading\">Travel Frequency</div> <div class=\"travel-freq-row\"> <div class=\"travel-freq-item\"> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"travelFreq\" ng-model=\"accountData.accountDetails.data.frequency\" value=\"1\"> <i></i> </label> <div class=\"freq-item-name\">Daily</div> </label> </div> <div class=\"travel-freq-item\"> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"travelFreq\" ng-model=\"accountData.accountDetails.data.frequency\" value=\"2\"> <i></i> </label> <div class=\"freq-item-name\">Monthly</div> </label> </div> </div> <div class=\"travel-freq-row\"> <div class=\"travel-freq-item\"> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"travelFreq\" ng-model=\"accountData.accountDetails.data.frequency\" value=\"3\"> <i></i> </label> <div class=\"freq-item-name\">Weekly</div> </label> </div> <div class=\"travel-freq-item\"> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"travelFreq\" ng-model=\"accountData.accountDetails.data.frequency\" value=\"4\"> <i></i> </label> <div class=\"freq-item-name\">Once in a while</div> </label> </div> </div> </div> <div> </div> </div> </div> <div class=\"ty-form-action-group\"> <button class=\"ty-button ty-button-orange\" type=\"submit\" ng-click=\"saveProfile()\"> UPDATE PROFILE </button> </div> </form> </div>"
  );


  $templateCache.put('views/tyhotelbookingdetails.html',
    "<div> <div class=\"ty-msg\" ng-class=\"{'ty-error': error,'ty-success':!error}\" ng-show=\"message\" ng-bind=\"message\"></div> <div ng-show=\"!reasonPage\"> <ty-booking-card view-type=\"viewType\" url-type=\"urlType\" booking-data=\"accountData.selectedBooking.card\"></ty-booking-card> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Check In</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.booking.order.hotel_booking.checkin_date | date: \"EEE, dd MMM yyyy\"}}</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Check Out</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.booking.order.hotel_booking.checkout_date | date: \"EEE, dd MMM yyyy\"}}</div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Booking ID.</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.booking.order.hotel_booking.booking_id}}</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">TY Booking ID</div> <div class=\"booking-detail-section-data\">{{::accountData.selectedBooking.data.booking.order.id}}</div> </div> </div> <div ng-if=\"viewType !== 'refund'\"> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-passenger-details\"> <div class=\"passenger-details-heading booking-detail-section-heading\"> <div class=\"detail-data\">Booked By</div> <div class=\"detail-data\">Rooms</div> <div class=\"detail-data\">Guests</div> <div class=\"detail-data\">Amout</div> </div> <div class=\"passenger-details-body booking-detail-section-data\"> <div class=\"detail-data\">{{::accountData.selectedBooking.data.booking.customer_details.name}}</div> <div class=\"detail-data\">{{::accountData.selectedBooking.data.booking.order.hotel_booking.rooms}}</div> <div class=\"detail-data\">{{::accountData.selectedBooking.data.booking.order.hotel_booking.adults}}</div> <div class=\"detail-data\">{{::accountData.selectedBooking.data.booking.order.hotel_booking.fareDetails.totalFare}}</div> </div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-detail-section-heading\"> Email: {{::accountData.selectedBooking.data.booking.customer_details.email}} </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-detail-section-heading\"> Mobile: +91 {{::accountData.selectedBooking.data.booking.customer_details.contactNo}} </div> </div> <div class=\"row booking-actions\"> <div class=\"col-xs-12\"> <div class=\"booking-action-btn-grp\"></div> </div> </div> </div> <div ng-if=\"viewType === 'refund'\"> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Cancellation Date</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\">{{strToDate(accountData.selectedBooking.refundDetails.CancelledDate) | date: \"dd MMM yyyy\"}}</div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Refund Amount</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\"><i class=\"icon-inr\"></i>{{::accountData.selectedBooking.refundDetails.RefundableAmount}}</div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Refund Status</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\">{{refundStatusMsg(accountData.selectedBooking.refundDetails.RefundStatus)}}</div> </div> </div>  </div>  <div class=\"row booking-actions\" ng-show=\"!reasonPage\"> <div class=\"col-xs-12\"> <div> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"printTicket(accountData.selectedBooking.card.orderId)\">Print</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"emailTicket(accountData.selectedBooking.card.orderId)\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">Email</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"smsTicket(accountData.selectedBooking.card.orderId, accountData.selectedBooking.data.booking.customer_details.email, accountData.selectedBooking.data.booking.customer_details.contactNo)\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">SMS</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"confirmCancelTicket()\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">Cancel</a> </div> <div ng-if=\"isCancelInitiated\"> <button class=\"ty-button ty-button-orange\" ng-click=\"proccedToCancelTicket()\" ng-disabled=\"accountData.isProcessing\"> CANCEL BOOKING </button> </div> </div> </div> </div> <div ng-show=\"reasonPage\"> <div class=\"cancel-confirmation\"> Choose reson for Cancellation <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Change of plan/dates\" value=\"Change of plan/dates\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\" ng-checked=\"true\"><i></i> </label> <span>Change of plan / dates</span> </label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Not travelling at all\" value=\"Not travelling at all\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i> </label> <span>Not travelling at all</span></label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Book other travel options\" value=\"Book other travel options\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i> </label> <span>Booked other travel options</span></label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Others\" value=\"Others\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i></label> <span>Others</span></label><i></i> </div> </div> <div class=\"row ty-input-group-inline ticket-submit-btn\"> <button class=\"ty-button ty-button-orange\" ng-click=\"cancelTicket(accountData.selectedBooking.card.orderId, accountData.selectedBooking.data.booking.customer_details.email)\" ng-disabled=\"disableFinalBtn\">CONFIRM CANCELLATION</button> </div> </div> </div>"
  );


  $templateCache.put('views/typrivilegecard.html',
    "<div class=\"container-fluid\"> <div class=\"row\"> <div class=\"col-md-12 section-heading\">Privilege Card</div> </div> <div class=\"row\"> <div class=\"col-md-7\"> <div class=\"container-fluid\"> <div class=\"row\"> <div class=\"col-xs-12 loyalty-section-header\">Summary</div> </div> <div class=\"row\"> <div class=\"col-xs-6 loyalty-details\">Total Points: {{accountData.loyaltyDetails.data.points}}</div> <div class=\"col-xs-6 loyalty-details\"><span ng-class=\"changeTierLabelColor(accountData.loyaltyDetails.data.tier)\">Tier: {{accountData.loyaltyDetails.data.tier}}</span></div> </div> <div class=\"row\"> <div class=\"col-xs-6 loyalty-details\">Transactions: {{accountData.loyaltyDetails.data.transactions}}</div> <div class=\"col-xs-6 loyalty-details\">Tier Discount: {{accountData.loyaltyDetails.data.discount}}</div> </div> </div> <div class=\"container-fluid loyalty-tier-structure\"> <div class=\"row\"> <div class=\"col-xs-12 loyalty-section-header\"> Tier Structure <span class=\"sub-header\">*only for bus tickets</span> </div> </div> <div class=\"row loyalty-tier-header\"> <div class=\"col-xs-4\">Tier</div> <div class=\"col-xs-2\">Bookings</div> <div class=\"col-xs-2\">Discounts</div> <div class=\"col-xs-4\">Points</div> </div> <div class=\"row loyalty-tier-row\"> <div class=\"col-xs-4 tier-name\">TY Platinum</div> <div class=\"col-xs-2\">60+</div> <div class=\"col-xs-2 tier-disc\">5%</div> <div class=\"col-xs-4\">60,000+</div> </div> <div class=\"row loyalty-tier-row\"> <div class=\"col-xs-4 tier-name\">TY Gold</div> <div class=\"col-xs-2\">26 - 60</div> <div class=\"col-xs-2 tier-disc\">4%</div> <div class=\"col-xs-4\">25,001 - 60,000</div> </div> <div class=\"row loyalty-tier-row\"> <div class=\"col-xs-4 tier-name\">TY Silver</div> <div class=\"col-xs-2\">11 - 25</div> <div class=\"col-xs-2 tier-disc\">3%</div> <div class=\"col-xs-4\">10,001 - 25,000</div> </div> <div class=\"row loyalty-tier-row\"> <div class=\"col-xs-4 tier-name\">TY Bronze</div> <div class=\"col-xs-2\">3 - 10</div> <div class=\"col-xs-2 tier-disc\">2%</div> <div class=\"col-xs-4\">2001 - 10,000</div> </div> <div class=\"row loyalty-tier-row\"> <div class=\"col-xs-4 tier-name\">TY Blue</div> <div class=\"col-xs-2\">0 - 2</div> <div class=\"col-xs-2 tier-disc\">1%</div> <div class=\"col-xs-4\">0 - 2000</div> </div> </div> </div> <div class=\"col-md-5\"> <div class=\"pvg-card-number-container\"> <div class=\"vertical-align\"> Travelyaari Privilege Card Number <div class=\"card-number\">{{accountData.loyaltyDetails.data.tpcn}}</div> </div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/tyrefundstatus.html',
    "<div>  <div class=\"container-fluid\"> <ul class=\"row head-nav\"> <li ng-click=\"setTab(1)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 1}\" target=\"_self\"> <div>ALL</div> </a> </li> <li ng-click=\"setTab(2)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 2}\" target=\"_self\"> <div>BUS</div> </a> </li> <li ng-click=\"setTab(3)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 3}\" target=\"_self\"> <div>HOTEL</div> </a> </li> <li ng-click=\"setTab(4)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 4}\" target=\"_self\"> <div>TOUR</div> </a> </li> <li ng-click=\"setTab(5)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 5}\" target=\"_self\"> <div>ACTIVITY</div> </a> </li> </ul> <div class=\"row\"> <div class=\"col-md-6 section-heading booking-list-container\"> Cancelled bookings </div> </div> <div class=\"row\"> <div ty-bookings-results ng-if=\"selectedTab == 1\"> <div ng-include=\"'views/tybookingallresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 2\"> <div ng-include=\"'views/tybookingbusresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 3\"> <div ng-include=\"'views/tybookinghotelresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 4\"> <div ng-include=\"'views/tybookingtourresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 5\"> <div ng-include=\"'views/tybookingactivityresults.html'\"></div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/tyslidelayer.html',
    "<div class=\"ty-slide-2 ty-slide-2-gravity-right {{::transformSupportClass}}\" ng-class=\"{'ty-show-slide-2':slideList && showSlide,'ty-is-app':$root.isApp}\"> <div class=\"ty-slide-2-inner\" ng-transclude ng-click=\"$event.stopPropagation()\"> </div> </div>"
  );


  $templateCache.put('views/tytourbookingdetails.html',
    "<div> <div class=\"ty-msg\" ng-class=\"{'ty-error': error,'ty-success':!error}\" ng-show=\"message\" ng-bind=\"message\"></div> <div ng-show=\"!reasonPage\"> <ty-booking-card view-type=\"viewType\" url-type=\"urlType\" booking-data=\"accountData.selectedBooking.card\"></ty-booking-card> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-passenger-details\"> <div class=\"passenger-details-heading booking-detail-section-heading\"> <div class=\"detail-data\">Booking Recipt No.</div> <div class=\"detail-data\">Booked by</div> <div class=\"detail-data\">No.of People</div> <div class=\"detail-data\">Fare</div> </div> <div class=\"passenger-details-body booking-detail-section-data\"> <div class=\"detail-data\">{{accountData.selectedBooking.data.booking.order.tour_booking.booking_id}}</div> <div class=\"detail-data\">{{accountData.selectedBooking.data.booking.customer_details.name}}</div> <div class=\"detail-data\">{{accountData.selectedBooking.data.booking.order.tour_booking.count}}</div> <div class=\"detail-data\">{{accountData.selectedBooking.data.booking.order.tour_booking.fareDetails.totalFare}}</div> </div> </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-detail-section-heading\"> Email: {{accountData.selectedBooking.data.booking.customer_details.email}} </div> </div> <div class=\"row booking-detail-section\"> <div class=\"col-xs-12 booking-detail-section-heading\"> Mobile: +91 {{accountData.selectedBooking.data.booking.customer_details.contactNo}} </div> </div> <div ng-if=\"viewType === 'refund'\"> <div class=\"row booking-detail-section\"> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-heading\">Refund Status</div> </div> <div class=\"col-xs-6\"> <div class=\"booking-detail-section-data\">Refund initiated</div> </div> </div> </div> <div class=\"row booking-actions\">  <div class=\"col-xs-12\"> <div ng-if=\"!isCancelInitiated\"> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"printTicket(accountData.selectedBooking.card.orderId)\">Print</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"emailTicket(accountData.selectedBooking.card.orderId)\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">Email</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"smsTicket(accountData.selectedBooking.card.orderId, accountData.selectedBooking.data.booking.customer_details.email, accountData.selectedBooking.data.booking.customer_details.contactNo)\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">SMS</a> <a href=\"javascript:void(0)\" class=\"ty-link ty-btn ty-btn-info\" ng-click=\"confirmCancelTicket()\" ng-if=\"!accountData.selectedBooking.card.isPrevious && !accountData.selectedBooking.card.isCancelled\">Cancel</a> </div> <div ng-if=\"isCancelInitiated\"> <button class=\"ty-button ty-button-orange\" ng-click=\"proccedToCancelTicket()\" ng-disabled=\"accountData.isProcessing\"> CANCEL BOOKING </button> </div> </div> </div> </div> <div ng-show=\"reasonPage\"> <div class=\"cancel-confirmation\"> Choose reson for Cancellation <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Change of plan/dates\" value=\"Change of plan/dates\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\" ng-checked=\"true\"><i></i> </label> <span>Change of plan / dates</span> </label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Not travelling at all\" value=\"Not travelling at all\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i> </label> <span>Not travelling at all</span></label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Book other travel options\" value=\"Book other travel options\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i> </label> <span>Booked other travel options</span></label> </div> <div> <label> <label class=\"ty-radio ty-radio-blue\"> <input type=\"radio\" name=\"Others\" value=\"Others\" ng-model=\"item.selectedValue\" ng-change=\"radioChanged(item)\"><i></i></label> <span>Others</span></label><i></i> </div> </div> <div class=\"row ty-input-group-inline ticket-submit-btn\"> <button class=\"ty-button ty-button-orange\" ng-click=\"cancelTicket(accountData.selectedBooking.card.orderId, accountData.selectedBooking.data.booking.customer_details.email)\" ng-disabled=\"disableFinalBtn\">CONFIRM CANCELLATION</button> </div> </div> </div>"
  );


  $templateCache.put('views/tyviewbookings.html',
    "<div>  <div class=\"container-fluid\"> <ul class=\"row head-nav\"> <li ng-click=\"setTab(1)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 1}\" target=\"_self\"> <div>ALL</div> </a> </li> <li ng-click=\"setTab(2)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 2}\" target=\"_self\"> <div>BUS</div> </a> </li> <li ng-click=\"setTab(3)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 3}\" target=\"_self\"> <div>HOTEL</div> </a> </li> <li ng-click=\"setTab(4)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 4}\" target=\"_self\"> <div>TOUR</div> </a> </li> <li ng-click=\"setTab(5)\"> <a class=\"ty-link\" ng-class=\"{'ty-link-orange ty-link-active' : selectedTab == 5}\" target=\"_self\"> <div>ACTIVITY</div> </a> </li> </ul> <div class=\"row\"> <div class=\"col-md-6 booking-list-container\"> <select class=\"booking-list\" ng-model=\"listType\" ng-change=\"gotoFilter()\"> <option value=\"upcoming\">Upcoming</option> <option value=\"previous\">Previous</option> <option value=\"cancelled\">Cancelled</option> <option value=\"all\">All Trips</option> </select> <span class=\"icon-arrow_drop_down dropdown-position\"></span> </div> </div> <div class=\"row\"> <div ty-bookings-results ng-if=\"selectedTab == 1\"> <div ng-include=\"'views/tybookingallresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 2\"> <div ng-include=\"'views/tybookingbusresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 3\"> <div ng-include=\"'views/tybookinghotelresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 4\"> <div ng-include=\"'views/tybookingtourresults.html'\"></div> </div> <div ty-bookings-results ng-if=\"selectedTab == 5\"> <div ng-include=\"'views/tybookingactivityresults.html'\"></div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/userbookings.html',
    "<div class=\"_acc\"> <ty-processing class=\"ty-loader-sm ty-account-loader\" loading=\"isProcessing\"></ty-processing> <div class=\"container tab-container\"> <div class=\"row\"> <div class=\"col-xs-3 account-navigator\"> <div class=\"row account-options\" ng-repeat=\"option in userVerificationData.userOptions\" ng-class=\"{'active': option.module == currentModule}\"> <a href=\"{{option.url}}\" class=\"ty-link ty-link-inherit-color\" target=\"{{option.target}}\"> <div class=\"col-xs-2\"> <i class=\"account-option-icon {{option.icon}}\"></i> </div> <div class=\"account-option-title col-xs-10\" ng-bind-html=\"option.title\"></div> </a> </div> </div> <div class=\"col-xs-9\"> <div> <div ng-repeat=\"option in userVerificationData.userOptions\" ng-include=\"option.view\" ng-if=\"option.module == currentModule\"></div> </div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/verifyuser.html',
    "<div class=\"_uv\"> <ty-processing loading=\"isProcessing\" class=\"ty-loader-sm ty-account-loader\"></ty-processing> <div class=\"container\" style=\"height: 350px\"> <div class=\"col-sm-5\" style=\"height: 100%\" ng-show=\"!isContactInfo\"> <div class=\"otp-heading\">View your Bookings</div> <div class=\"ty-msg\" ng-class=\"{'ty-error': userVerificationData.error,'ty-success':!userVerificationData.error}\" ng-show=\"userVerificationData.message\" ng-bind=\"userVerificationData.message\"></div> <div>Provide mobile number or email address associated with your bookings, we will send one time password (OTP) to verify you.</div> <form class=\"ty-form user-verify-form\" name=\"userVerify\" ng-submit=\"getOtp()\" novalidate> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : !userVerify.mobile.$viewValue.length && userVerify.$submitted && userVerify.email.$invalid}\"> <input class=\"ty-form-control\" name=\"email\" type=\"email\" ng-required=\"!userVerify.mobile.$viewValue.length\" ng-model=\"otpEmail\" ng-disabled=\"userVerify.mobile.$viewValue.length\"> <label>Enter email address</label> </div> <div style=\"text-align: center\"> <div class=\"ty-circle\">or</div> </div> <div class=\"ty-input-group ty-input-group-borderless row\" ng-class=\"{'ty-input-error' : !userVerify.email.$viewValue.length && userVerify.$submitted && userVerify.mobile.$invalid}\"> <div class=\"col-xs-3 otp-nation-code\"> <select class=\"ty-form-control\"> <option>+91</option> <option>Intl.</option> </select> </div> <div class=\"col-xs-9 otp-mobile\"> <input class=\"ty-form-control\" name=\"mobile\" type=\"tel\" maxlength=\"10\" ng-model=\"otpMobile\" ng-required=\"!userVerify.email.$viewValue.length\" ty-validate-on-keypress=\"number\" ng-minlength=\"10\" ng-disabled=\"userVerify.email.$viewValue.length\"> <label>Enter Mobile Number</label> </div> </div> <div class=\"ty-button-container\"> <button class=\"ty-button ty-button-orange\" type=\"submit\"> SUBMIT </button> </div> </form> </div> <div class=\"col-sm-5\" style=\"height: 100%\" ng-show=\"isContactInfo\"> <div class=\"otp-heading\">Verify your Identity</div> <div class=\"ty-msg\" ng-class=\"{'ty-error': userVerificationData.error,'ty-success':!userVerificationData.error}\" ng-show=\"userVerificationData.message\" ng-bind=\"userVerificationData.message\"></div> <div>{{userVerificationData.userData.remark}}</div> <div> <a class=\"ty-link\" href=\"javascript:void(0)\" ng-click=\"isContactInfo = false;\">Edit</a> &nbsp;&nbsp;&nbsp;<a class=\"ty-link\" href=\"javascript:void(0)\" ng-click=\"getOtp()\">Resend</a> </div> <form class=\"ty-form user-verify-form\" name=\"otpVerify\" ng-submit=\"verifyOtp()\" novalidate> <div class=\"ty-info-label\"> <label>OTP (valid till next 10 minutes only)</label> </div> <div class=\"ty-input-group ty-input-group-borderless\" ng-class=\"{'ty-input-error' : otpVerify.$submitted && otpVerify.otp.$invalid}\"> <input class=\"ty-form-control\" name=\"otp\" type=\"tel\" ng-required=\"true\" ng-model=\"otp\"> <label>Enter OTP for validation</label> </div> <div class=\"ty-button-container\"> <button class=\"ty-button ty-button-orange\" ng-disabled=\"\" type=\"submit\"> VERIFY </button> </div> </form> <div> <div class=\"delayed-msg\" ng-show=\"showDelayedMsg\"> Not recieved OTP<br>Use other option to <a href=\"/print/bus\" class=\"ty-link\">view your booking</a> </div> </div> </div> <div class=\"col-sm-1\" style=\"min-height: 50px\"></div> <div class=\"col-sm-6\" style=\"height: 100%\"> <div class=\"otp-img-container\"> <div class=\"login-btn-container\"> <div class=\"heading\">Manage your Bookings</div> <button class=\"ty-button ty-button-login\" type=\"submit\" onclick=\"window.location.href='/login'\"> LOGIN </button> to view all your bookings </div> </div> </div> </div> </div>"
  );


  $templateCache.put('views/viewbooking.html',
    "<div class=\"_vb\"> <ty-view-bookings url-type=\"urlType\"></ty-view-bookings> </div>"
  );

}]);
